export const common = {
  // Navigation
  'nav.features': 'Fonctionnalités',
  'nav.howItWorks': 'Comment ça marche',
  'nav.pricing': 'Tarifs',
  'nav.faq': 'FAQ',
  'nav.aboutUs': 'À propos',
  'nav.getStarted': 'Commencer',

  // About Us Section
  'aboutUs.badge': "À propos",
  'aboutUs.title': "Nous discutons avec votre idée pour qu'elle n'ait pas à discuter avec la réalité plus tard.",
  'aboutUs.line1': "La plupart des idées n'échouent pas par manque de talent du fondateur.",
  'aboutUs.line2': "Elles échouent parce que personne n'a dit la vérité assez tôt — quand changer de cap était encore bon marché.",
  'aboutUs.paragraph1':
    "IdeaVerdict comble ce vide. Nous testons votre idée sous pression contre les signaux de marché qui décident vraiment des résultats : demande, concurrence, capital, temps, scalabilité. Nous ne vendons pas de motivation. Nous vendons des preuves de marché.",
  'aboutUs.belief1a': "Nous ne vendons pas de motivation.",
  'aboutUs.belief1b': "Nous vendons des preuves de marché.",
  'aboutUs.belief2a': "Nous ne vendons pas d'espoir.",
  'aboutUs.belief2b': "Nous vendons une lecture claire de ce que votre idée doit affronter.",
  'aboutUs.mission1': "Notre travail n'est pas de faire briller votre idée.",
  'aboutUs.mission2': "Notre travail est de vous dire si elle brille vraiment.",
  'aboutUs.analysis':
    "Nous évaluons votre idée sur sept facteurs qui décident de sa survie : demande, concurrence, capital initial, délai de revenu, potentiel de profit, scalabilité et risque. Pas d'émotion. Pas d'optimisme. Seulement de l'analyse.",
  'aboutUs.failure1': "La plupart des entreprises échouent.",
  'aboutUs.failure2': "Pas parce que les gens derrière étaient incompétents —",
  'aboutUs.failure3': "mais parce que personne n'a contre-argumenté assez fort, assez tôt.",
  'aboutUs.clarity': "Nous existons pour contre-argumenter.",
  'aboutUs.value1': "Direct.",
  'aboutUs.value2': "Honnête.",
  'aboutUs.value3': "Rapide.",
  'aboutUs.confirm': "Si votre idée a de la substance, nous la soutenons.",
  'aboutUs.deny': "Sinon, nous vous le disons en face.",
  'aboutUs.noApplause': "Pas d'applaudissements.",
  'aboutUs.noSugarcoating': "Pas de flatterie.",
  'aboutUs.noTheater': "Pas de théâtre.",
  'aboutUs.noHype': "Juste le verdict.",
  // Hero Section
  'hero.badge': 'Décidez avant de construire',
  'hero.title1': "Votre idée, notée par une IA",
  'hero.title2': "qui ne vous flattera pas.",
  'hero.subtitle': "Sept dimensions exigeantes. Un verdict. En moins d'une minute.",
  'hero.subtitleLine2': "Découvrez si votre idée d'entreprise a une vraie chance — avant de passer l'année prochaine à l'apprendre à la dure.",
  'hero.cta': 'Noter mon idée',
  'hero.ctaSecondary': 'Voir comment ça marche',
  'hero.stat1Value': '30',
  'hero.stat1Label': 'Crédits par requête',
  'hero.stat2Value': '7',
  'hero.stat2Label': "Dimensions d'évaluation",
  'hero.stat3Value': '100%',
  'hero.stat3Label': 'Honnête & privé',

  // Features Section
  'features.title1': 'Conçu pour',
  'features.title2': 'les fondateurs',
  'features.title3': 'qui veulent du signal, pas du bruit.',
  'features.bullet1.title': "Un second avis auquel vous pouvez vous fier",
  'features.bullet1.description':
    "Chaque analyse est notée Solide, Mitigée ou Faible — avec le raisonnement derrière. Pas d'applaudissements, pas de flatterie. Juste ce que le marché vous renverra probablement.",
  'features.bullet2.title': "Noté sur ce qui compte pour le marché",
  'features.bullet2.description':
    "Demande réelle. Concurrence. Capital nécessaire. Délai de revenu. Scalabilité. Les choses que les VC regardent en premier — appliquées à votre idée avant que vous n'ayez rien construit.",
  'features.bullet3.title': "De l'idée à un plan prêt pour les développeurs",
  'features.bullet3.description':
    "Le mode Builder convertit un verdict validé en brief structuré : parcours utilisateur, fonctionnalités clés, notes techniques. Vous sautez le tableau blanc et le remettez directement à un ingénieur.",

  // How It Works
  'howItWorks.title': 'Comment ça marche',
  'howItWorks.subtitle': "Quatre étapes. Environ dix minutes au total.",
  'howItWorks.step1Title': 'Choisissez votre profondeur',
  'howItWorks.step1Desc': "Starter pour des vérifications rapides. Pro pour une analyse complète. Builder pour des briefs prêts à expédier. Choisissez ce qui correspond à votre étape.",
  'howItWorks.step2Title': "Décrivez votre idée à l'IA",
  'howItWorks.step2Desc': "Un paragraphe. Plus vous l'écrivez clairement, plus le verdict est précis. Chaque analyse coûte 30 crédits.",
  'howItWorks.step3Title': 'Lisez le verdict',
  'howItWorks.step3Desc': "Solide, Mitigé ou Faible — sur sept dimensions. Plus un score sur 100 que vous pouvez contester.",
  'howItWorks.step4Title': 'Décidez de la suite',
  'howItWorks.step4Desc': "Construire. Affiner. Pivoter. Abandonner. Vous saurez quoi faire — et pourquoi.",

  // Pricing
  'pricing.title': 'Tarifs',
  'pricing.subtitle': 'Choisissez le forfait qui correspond à la profondeur de votre analyse.',
  'pricing.monthly': 'Mensuel',
  'pricing.yearly': 'Annuel',
  'pricing.yearlyDiscount': 'Abonnement annuel :',
  'pricing.yearlyDiscountValue': '-20% de réduction',
  'pricing.perMonth': 'par mois',
  'pricing.selectPlan': 'Choisir ce forfait',
  'pricing.mostPopular': 'Le plus populaire',
  'pricing.footer':
    'Tous les prix en CHF. Les crédits ne sont déduits que pour les réponses IA réussies.',

  
  // Pricing Features
  'pricing.feature1': 'Chat gratuit (sans formulaire)',
  'pricing.feature2': 'Logique de marché et évaluation honnête',
  'pricing.feature3': 'Historique de chat persistant',
  'pricing.feature4': 'Plusieurs sessions de chat parallèles',
  'pricing.feature5': 'Entièrement multilingue',
  'pricing.feature6': 'Utilisation basée sur des crédits',
  'pricing.feature7': 'Réinitialisation mensuelle',
  'pricing.feature8': 'Analyse de marché',
  'pricing.feature9': 'Résumé',
  'pricing.feature10': 'Points forts',
  'pricing.feature11': 'Points faibles',
  'pricing.feature12': 'Opportunités',
  'pricing.feature13': 'Risques',
  'pricing.feature14': 'Recommandations',
  'pricing.feature15': 'Télécharger le PDF',
  'pricing.feature16': 'Aucun briefing technique',
  'pricing.feature17': 'Mode Builder : Briefings développeur',
  'pricing.feature18': 'Résumé structuré',

  // Starter Plan
  'pricing.starter.name': 'Starter',
  'pricing.starter.price': '39.90',
  'pricing.starter.description': 'Accès au chatbot IA de niche',
  'pricing.starter.credits': '2 500 crédits par mois',
  'pricing.starter.feature1': 'Générer une idée de niche',
  'pricing.starter.feature2': 'Affiner une niche',
  'pricing.starter.feature3': 'Vérification réaliste du marché',
  'pricing.starter.feature4': 'Évaluation de la concurrence',
  'pricing.starter.feature5': 'Évaluation du temps',
  'pricing.starter.feature6': 'Verdict honnête',
  'pricing.starter.feature7': 'Sessions privées',
  'pricing.starter.feature8': 'Historique et export',

  // Pro Plan
  'pricing.pro.name': 'Pro',
  'pricing.pro.price': '59.90',
  'pricing.pro.description': 'Accès au chatbot IA de niche',
  'pricing.pro.credits': '5 000 crédits par mois',
  'pricing.pro.feature1': 'Toutes les fonctionnalités Starter',
  'pricing.pro.feature2': 'Plus de crédits pour une analyse intensive',
  'pricing.pro.feature3': 'Suggestions d\'amélioration',
  'pricing.pro.feature4': 'Niches alternatives',
  'pricing.pro.feature5': 'Analyse détaillée du marché',
  'pricing.pro.feature6': 'Support prioritaire',
  'pricing.pro.feature7': 'Filtres avancés',
  'pricing.pro.feature8': 'Favoris de session',

  // Builder Plan
  'pricing.builder.name': "Builder",
  'pricing.builder.price': '199',
  'pricing.builder.description': "Toutes les fonctionnalités + mode Builder",
  'pricing.builder.credits': "10 000 crédits par mois",
  'pricing.builder.feature1': 'Toutes les fonctionnalités Pro',
  'pricing.builder.feature2': 'Requêtes IA illimitées',
  'pricing.builder.feature3': 'Mode Builder : Cahiers des charges développeur',
  'pricing.builder.feature4': 'Aperçu structuré du projet',
  'pricing.builder.feature5': 'Parcours utilisateur et fonctionnalités clés',
  'pricing.builder.feature6': 'Notes techniques',
  'pricing.builder.feature7': 'Définir les non-objectifs',
  'pricing.builder.feature8': 'Limite d\'utilisation équitable',
  'pricing.builder.limitNote': 'Limite d\'utilisation équitable',
  'pricing.monthlyReset': 'Réinitialisation mensuelle',

  // Modal
  'pricing.modal.selected': 'sélectionné',
  'pricing.modal.comingSoon':
    'L\'inscription et le traitement des paiements seront bientôt disponibles.',
  'pricing.modal.patience':
    'Nous travaillons pour vous offrir une expérience sécurisée et fluide. Merci de votre patience.',
  'pricing.modal.understood': 'Compris',

  // FAQ
  'faq.title': 'FAQ',
  'faq.subtitle': 'Réponses directes, pas de marketing.',
  'faq.q1': "Que fait vraiment IdeaVerdict ?",
  'faq.a1': "Il évalue votre idée d'entreprise sur les sept facteurs qui décident si elle survit à un marché : demande, concurrence, capital initial, délai de revenu, potentiel de profit, scalabilité et risque.\nVous obtenez un verdict, un score, et le raisonnement derrière les deux.",
  'faq.q2': "Pouvez-vous générer des idées, ou seulement critiquer les miennes ?",
  'faq.a2': "Les deux.\nDites-nous quelles sont vos compétences, votre capital et votre temps — nous ferons remonter des niches avec de vrais manques de marché.\nOu collez la vôtre et nous la dissèquerons.",
  'faq.q3': "En quoi êtes-vous différents de ChatGPT ?",
  'faq.a3': "ChatGPT essaie d'être utile.\nNous essayons d'être précis.\nNous sommes calibrés pour contre-argumenter quand les chiffres ne tiennent pas — au lieu de trouver des raisons pour lesquelles votre idée est géniale.",
  'faq.q4': "Cela garantit-il que mon idée réussira ?",
  'faq.a4': "Aucun outil ne garantit cela.\nNous vous aidons à éviter les paris manifestement mauvais et à affûter ceux qui ont une chance.\nLe risque ne disparaît pas — mais vous y allez les yeux ouverts.",
  'faq.q5': "Pour qui est-ce ?",
  'faq.a5': "Fondateurs avant le lancement.\nOpérateurs avant un pari secondaire.\nBuilders avant le projet du week-end.\nInvestisseurs avant le chèque.\n\nToute personne qui veut de la clarté avant l'engagement.",
  'faq.q6': "Et si je veux juste qu'on me dise que mon idée est géniale ?",
  'faq.a6': "Alors nous sommes le mauvais outil.\nNous donnons une lecture honnête, pas du réconfort.",
  'faq.q7': "À quel point l'analyse est-elle vraiment honnête ?",
  'faq.a7': "Aussi honnête que les données le permettent.\nNous n'adoucissons pas un verdict faible pour ménager les sentiments.\nSi votre idée a un problème, nous le dirons — et nous dirons où il se trouve.",
  'faq.q8': "Cela remplace-t-il une vraie étude de marché ?",
  'faq.a8': "Non.\nC'est un check stratégique rapide avant d'engager du temps et de l'argent — pas un rapport de 50 pages.\nUtilisez-nous pour décider si la recherche plus profonde vaut la peine.",
  'faq.q9': "Qu'apporte le mode Builder ?",
  'faq.a9': "Une fois qu'un verdict est positif, le mode Builder le transforme en brief développeur : parcours utilisateur, fonctionnalités clés, modèle de monétisation, considérations techniques.\nLe document que vous donneriez à votre premier ingénieur.",
  'faq.q10': "Pourquoi si direct ?",
  'faq.a10': "Parce que construire la mauvaise chose coûte des mois.\nUn verdict honnête coûte des minutes.\n\nNous choisissons les minutes.",
  // Footer
  'footer.description':
    "IdeaVerdict n'est pas là pour vous faire vous sentir bien à propos de votre idée. Il est là pour vous aider à décider s'il faut parier dessus.",
  'footer.product': 'Produit',
  'footer.aiAssistant': 'Assistant IA',
  'footer.howItWorks': 'Comment ça marche',
  'footer.pricing': 'Tarifs',
  'footer.faq': 'FAQ',
  'footer.legal': 'Mentions légales',
  'footer.privacy': 'Confidentialité',
  'footer.terms': 'Conditions',
  'footer.imprint': 'Impressum',
  'footer.support': 'Support',
  'footer.contact': 'Contact',
  'footer.documentation': 'Documentation',
  'footer.copyright': '© 2026 IdeaVerdict. Tous droits réservés.',

  // AI Assistant
  'aiAssistant.title': 'Assistant IA pour Niches',
  'aiAssistant.subtitle': 'Posez vos questions sur les niches',
  'aiAssistant.welcomeMessage':
    'Bonjour ! Décrivez votre idée ou interrogez-moi sur une niche. Je vous donnerai une évaluation claire et honnête.',
  'aiAssistant.demoResponse':
    'Ceci est une démo. Pour obtenir de vraies évaluations IA, veuillez vous inscrire et choisir un forfait.',
  'aiAssistant.placeholder': 'Décrivez votre idée...',

  // Header & Sidebar
  'dashboard.header.title': 'Tableau de bord',
  'dashboard.header.aiAssistant': 'Votre assistant IA',
  'header.logout': 'Déconnexion',
  'dashboard.sidebar.overview': 'Aperçu',
  'dashboard.sidebar.aiChat': 'Assistant IA',
  'dashboard.sidebar.newAnalysis': 'Assistant IA',
  'dashboard.sidebar.history': 'Historique',
  'dashboard.sidebar.credits': 'Crédits',
  'dashboard.sidebar.settings': 'Paramètres',

  // Dashboard Overview
  'dashboard.overview.welcome': 'Bon retour, {{name}}',
  'dashboard.overview.subtitle':
    'Voici un aperçu rapide de votre activité',

  // Dashboard Stats
  'dashboard.stats.creditsRemaining': 'Crédits restants',
  'dashboard.stats.totalAnalyses': 'Analyses totales',
  'dashboard.stats.goodRatings': 'Évaluations positives',
  'dashboard.stats.nextReset': 'Prochaine réinitialisation dans',
  'dashboard.stats.days': 'jours',

  // Quick Actions
  'dashboard.quickActions.title': 'Actions rapides',
  'dashboard.quickActions.checkNewIdea': 'Évaluer une idée',
  'dashboard.quickActions.checkNewIdeaDesc':
    'Analyser une idée d\'entreprise existante',
  'dashboard.quickActions.generateIdea': 'Générer une idée',
  'dashboard.quickActions.generateIdeaDesc':
    'Trouver une nouvelle niche rentable',
  'dashboard.quickActions.builderBriefing': 'Briefing Builder',
  'dashboard.quickActions.builderBriefingDesc':
    'Transformer une idée en cahier des charges prêt développeur',
  'dashboard.quickActions.premiumOnly': 'Builder uniquement',

  // Chat Header
  'chat.title': 'Assistant IA pour Niches',
  'chat.subtitle':
    'Posez des questions sur les niches. J\'évalue de manière critique et honnête.',
  'chat.creditsLabel': 'Crédits',

  // Chat Welcome
  'chat.welcomeTitle': 'Bienvenue dans l\'Assistant IA pour Niches',
  'chat.welcomeDesc':
    'Décrivez votre idée ou posez une question sur une niche. Je l\'évaluerai honnêtement : Bon, Moyen ou Mauvais.',
  'chat.aiWelcome':
    'Bonjour ! Décrivez votre idée ou interrogez-moi sur une niche. Je vous donnerai une évaluation claire et honnête.',

  // Chat Suggestions
  'chat.suggestion1': 'Je veux créer un outil SaaS pour les freelances pour gérer leurs factures. Est-ce une bonne niche ?',
  'chat.suggestion2': 'Trouve-moi un business en ligne peu concurrentiel que je peux lancer avec 500 CHF sans savoir coder.',
  'chat.suggestion3': 'Évalue ceci : une appli de planification de repas par IA pour parents débordés avec des restrictions alimentaires.',
  'chat.suggestion4': 'Je veux vendre des templates numériques sur Etsy pour les petites entreprises. Analyse cette niche honnêtement.',

  // Chat Actions
  'chat.newConversation': 'Nouvelle conversation',
  'chat.today': 'Aujourd\'hui',
  'chat.yesterday': 'Hier',
  'chat.thisWeek': 'Cette semaine',
  'chat.thisMonth': 'Ce mois-ci',
  'chat.older': 'Plus ancien',
  'chat.messages': 'messages',
  'chat.renameConversation': 'Renommer',
  'chat.deleteConversation': 'Supprimer',
  'chat.cancel': 'Annuler',
  'chat.rename': 'Renommer',
  'chat.delete': 'Supprimer',
  'chat.favorite': 'Ajouter aux favoris',
  'chat.unfavorite': 'Retirer des favoris',
  'chat.searchSessions': 'Rechercher des conversations...',
  'chat.noResults': 'Aucun résultat trouvé',
  'chat.noSessions': 'Aucune conversation pour le moment',
  'chat.enterNewName': 'Entrez un nouveau nom...',
  'chat.deleteConfirmMessage':
    'Êtes-vous sûr de vouloir supprimer cette conversation ? Cette action est irréversible.',

  // Chat Input & Errors
  'chat.inputPlaceholder': 'Tapez votre question… (coûte 30 crédits)',
  'chat.send': 'Envoyer',
  'chat.voice': 'Parler',
  'chat.listeningPlaceholder': 'Je vous écoute... Parlez maintenant.',
  'chat.stopListening': 'Arrêter l\'écoute',
  'chat.recording': 'Enregistrement...',
  'chat.speechNotSupported': 'Votre navigateur ne supporte pas la reconnaissance vocale.',
  'chat.microphonePermissionDenied': 'Accès au microphone refusé. Veuillez autoriser l\'accès dans les paramètres de votre navigateur.',
  'chat.errorNotEnoughCredits':
    'Crédits insuffisants. Veuillez améliorer votre forfait ou attendre la prochaine réinitialisation.',
  'chat.errorAiFailed': 'La réponse IA a échoué. Aucun crédit n\'a été déduit.',
  'chat.errorRateLimit': 'Trop de requêtes. Veuillez patienter un moment.',

  // Ratings
  'rating.good': 'Bon',
  'rating.medium': 'Moyen',
  'rating.bad': 'Mauvais',

  // Auth Page
  'auth.branding.headline1': 'Toutes les idées ne sont pas bonnes.',
  'auth.branding.headline2': 'Nous vous le disons honnêtement.',
  'auth.branding.subtitle':
    'Une IA décisionnelle pour les niches commerciales. Claire. Critique. Sans fioritures.',
  'auth.benefits.privacy.title': '100% Privé',
  'auth.benefits.privacy.desc':
    'Vos idées restent complètement privées et sécurisées.',
  'auth.benefits.honest.title': 'IA Honnête',
  'auth.benefits.honest.desc':
    'Pas de fioritures – juste un retour clair et critique.',
  'auth.benefits.fast.title': 'Résultats Rapides',
  'auth.benefits.fast.desc': 'Obtenez de la clarté sur votre niche en quelques minutes.',
  'auth.trust.users': 'Utilisateurs actifs',
  'auth.trust.ideas': 'Idées analysées',
  'auth.trust.rating': 'Note utilisateur',
  'auth.login.title': 'Connexion',
  'auth.login.headline': 'Bon retour',
  'auth.login.subtitle': 'Connectez-vous pour continuer votre aventure.',
  'auth.login.forgotPassword': 'Mot de passe oublié ?',
  'auth.login.submit': 'Se connecter',
  'auth.login.noAccount': 'Pas encore de compte ?',
  'auth.login.signUp': 'S\'inscrire',
  'auth.register.title': 'Inscription',
  'auth.register.headline': 'Créez votre compte',
  'auth.register.subtitle':
    'Commencez à analyser vos idées d\'entreprise dès aujourd\'hui.',
  'auth.register.submit': 'Créer le compte',
  'auth.register.hasAccount': 'Vous avez déjà un compte ?',
  'auth.register.signIn': 'Se connecter',
  'auth.fields.name': 'Nom complet',
  'auth.fields.email': 'Adresse e-mail',
  'auth.fields.password': 'Mot de passe',
  'auth.fields.confirmPassword': 'Confirmer le mot de passe',
  'auth.fields.selectPlan': 'Choisissez votre forfait',
  'auth.fields.testCode': 'Code de test pour vous connecter',
  'auth.placeholders.name': 'Entrez votre nom',
  'auth.placeholders.email': 'Entrez votre e-mail',
  'auth.placeholders.password': 'Entrez votre mot de passe',
  'auth.placeholders.confirmPassword': 'Confirmez votre mot de passe',
  'auth.placeholders.testCode': 'Entrez le code de test',
  'auth.terms.accept': 'J\'accepte les',
  'auth.terms.terms': 'Conditions générales',
  'auth.privacy.accept': 'J\'accepte la',
  'auth.privacy.policy': 'Politique de confidentialité',
  'auth.errors.nameRequired': 'Le nom est requis',
  'auth.errors.emailRequired': 'L\'e-mail est requis',
  'auth.errors.emailInvalid': 'Veuillez entrer un e-mail valide',
  'auth.errors.passwordRequired': 'Le mot de passe est requis',
  'auth.errors.passwordLength': 'Le mot de passe doit comporter au moins 8 caractères',
  'auth.errors.passwordMismatch': 'Les mots de passe ne correspondent pas',
  'auth.errors.invalidCode': 'Code invalide ou expiré',
  'auth.errors.registrationCodeOnly': 'Ce code est uniquement pour l\'inscription',
  'auth.errors.verificationFailed': 'Erreur lors de la vérification du code. Veuillez réessayer.',
  'auth.loading': 'Veuillez patienter...',
  'auth.or': 'ou continuer avec',
  'auth.social.google': 'Continuer avec Google',
  'auth.social.apple': 'Continuer avec Apple',
  'auth.actions.verify': 'Vérifier',
  'auth.testCode.activated': 'Code de test activé !',
  'auth.testCode.days': 'jours',
  'auth.testCode.months': 'mois',
  'auth.testCode.freeAccess': 'accès gratuit',
  'auth.testCode.credits': 'crédits',

  // Email Verification
  'auth.verification.title': 'Vérifier l\'e-mail',
  'auth.verification.headline': 'Vérifiez votre boîte de réception',
  'auth.verification.subtitle': 'Nous avons envoyé un code de vérification à :',
  'auth.verification.codeLabel': 'Code de vérification',
  'auth.verification.codePlaceholder': 'Entrez le code à 6 chiffres',
  'auth.verification.submit': 'Vérifier l\'e-mail',
  'auth.verification.resend': 'Renvoyer le code',
  'auth.verification.resendIn': 'Renvoyer dans',
  'auth.verification.seconds': 'secondes',
  'auth.verification.success': 'E-mail vérifié avec succès !',
  'auth.verification.error': 'Code invalide. Veuillez réessayer.',
  'auth.verification.expired': 'Code expiré. Veuillez en demander un nouveau.',
  'auth.verification.sent': 'Nouveau code envoyé !',
  'auth.verification.checkSpam':
    'Vous ne l\'avez pas reçu ? Vérifiez votre dossier spam.',

  // Forgot Password
  'auth.forgot.title': 'Mot de passe oublié',
  'auth.forgot.headline': 'Réinitialisez votre mot de passe',
  'auth.forgot.subtitle':
    'Entrez votre adresse e-mail et nous vous enverrons un lien de réinitialisation.',
  'auth.forgot.submit': 'Envoyer le lien',
  'auth.forgot.backToLogin': 'Retour à la connexion',
  'auth.forgot.success': 'E-mail envoyé !',
  'auth.forgot.successMessage':
    'Nous vous avons envoyé un e-mail avec les instructions pour réinitialiser votre mot de passe.',
  'auth.forgot.checkInbox': 'Vérifiez votre boîte de réception',

  // Reset Password
  'auth.reset.title': 'Nouveau mot de passe',
  'auth.reset.headline': 'Définir un nouveau mot de passe',
  'auth.reset.subtitle': 'Entrez votre nouveau mot de passe.',
  'auth.reset.newPassword': 'Nouveau mot de passe',
  'auth.reset.confirmNewPassword': 'Confirmer le nouveau mot de passe',
  'auth.reset.submit': 'Modifier le mot de passe',
  'auth.reset.success': 'Mot de passe modifié avec succès !',
  'auth.reset.successMessage':
    'Vous pouvez maintenant vous connecter avec votre nouveau mot de passe.',
  'auth.reset.loginNow': 'Se connecter maintenant',

  // Legal Pages
  'legal.backToAuth': 'Retour à la connexion',
  'legal.allRightsReserved': 'Tous droits réservés.',

  // Terms Page
  'legal.terms.title': 'Conditions générales',
  'legal.terms.lastUpdated': 'Dernière mise à jour',
  'legal.terms.section1.title': '1. Champ d\'application',
  'legal.terms.section1.content':
    'Les présentes conditions générales s\'appliquent à tous les contrats entre NicheFinder (ci-après le "Fournisseur") et l\'utilisateur (ci-après le "Client") concernant l\'utilisation de la plateforme d\'analyse de niche basée sur l\'IA.',
  'legal.terms.section2.title': '2. Description des services',
  'legal.terms.section2.content':
    'Le Fournisseur propose une plateforme basée sur l\'IA qui analyse et évalue les idées et niches commerciales. Les services comprennent :',
  'legal.terms.section2.item1': 'Analyse par IA des idées commerciales',
  'legal.terms.section2.item2': 'Évaluation du potentiel de marché et de la concurrence',
  'legal.terms.section2.item3': 'Génération de suggestions de niches',
  'legal.terms.section2.item4': 'Création de cahiers des charges développeur (forfait Builder)',
  'legal.terms.section3.title': '3. Conclusion du contrat et inscription',
  'legal.terms.section3.content':
    'Le contrat est conclu par l\'inscription sur la plateforme et le choix d\'un forfait. Le client confirme :',
  'legal.terms.section3.item1': 'Être majeur et pleinement capable',
  'legal.terms.section3.item2': 'Fournir des informations véridiques lors de l\'inscription',
  'legal.terms.section3.item3': 'Conserver les identifiants de manière sécurisée',
  'legal.terms.section4.title': '4. Crédits et facturation',
  'legal.terms.section4.content':
    'L\'utilisation des fonctionnalités IA repose sur un système de crédits. Chaque requête IA coûte 30 crédits. Les crédits ne sont déduits qu\'en cas de réponse réussie. Les crédits non utilisés expirent à la fin de la période de facturation et ne sont pas remboursés.',
  'legal.terms.section5.title': '5. Limitation de responsabilité',
  'legal.terms.section5.content':
    'Les évaluations de l\'IA servent uniquement d\'aide à la décision et ne garantissent pas le succès commercial. Le Fournisseur n\'est pas responsable des décisions prises sur la base des analyses de l\'IA. La responsabilité pour intention ou négligence grave reste inchangée.',
  'legal.terms.section6.title': '6. Protection des données et confidentialité',
  'legal.terms.section6.content':
    'Toutes les idées commerciales soumises sont traitées de manière confidentielle et ne sont pas partagées avec des tiers. Le traitement des données personnelles est effectué conformément à notre politique de confidentialité et aux lois applicables sur la protection des données.',
  'legal.terms.section7.title': '7. Résiliation',
  'legal.terms.section7.content':
    'Le client peut résilier son abonnement à tout moment pour la fin de la période de facturation en cours. En cas de violation des présentes conditions, le Fournisseur se réserve le droit de bloquer l\'accès à la plateforme.',
  'legal.terms.section8.title': '8. Dispositions finales',
  'legal.terms.section8.content':
    'Le droit suisse s\'applique. Le lieu de juridiction est Zurich, Suisse. Si certaines dispositions des présentes conditions sont invalides, la validité des autres dispositions reste inchangée.',
  'legal.terms.contact.title': 'Des questions sur les conditions ?',
  'legal.terms.contact.content':
    'Si vous avez des questions sur ces conditions générales, veuillez nous contacter à :',

  // Privacy Page
  'legal.privacy.title': 'Politique de confidentialité',
  'legal.privacy.section1.title': '1. Responsable du traitement',
  'legal.privacy.section1.content':
    'Le responsable du traitement pour ce site web est NicheFinder, Zurich, Suisse. Nous prenons très au sérieux la protection de vos données personnelles et traitons vos données personnelles de manière confidentielle et conformément aux réglementations légales sur la protection des données.',
  'legal.privacy.section2.title': '2. Données collectées',
  'legal.privacy.section2.content':
    'Nous collectons et traitons les données personnelles suivantes :',
  'legal.privacy.section2.item1':
    'Données d\'inscription : Nom, adresse e-mail, mot de passe (crypté)',
  'legal.privacy.section2.item2':
    'Données d\'utilisation : Adresse IP, type de navigateur, heures d\'accès',
  'legal.privacy.section2.item3':
    'Idées commerciales et requêtes de niche (stockées anonymement)',
  'legal.privacy.section2.item4':
    'Informations de paiement (via des prestataires tiers sécurisés)',
  'legal.privacy.section3.title': '3. Finalité du traitement des données',
  'legal.privacy.section3.content':
    'Vos données sont utilisées aux fins suivantes :',
  'legal.privacy.section3.item1':
    'Fourniture et amélioration de nos services IA',
  'legal.privacy.section3.item2':
    'Gestion du compte et authentification',
  'legal.privacy.section3.item3':
    'Facturation et traitement des paiements',
  'legal.privacy.section4.title': '4. Sécurité des données',
  'legal.privacy.section4.content':
    'Nous mettons en œuvre des mesures de sécurité techniques et organisationnelles pour protéger vos données contre la manipulation, la perte, la destruction ou l\'accès non autorisé. Tous les transferts de données sont cryptés via SSL/TLS.',
  'legal.privacy.section5.title': '5. Confidentialité de vos idées commerciales',
  'legal.privacy.section5.content':
    'Vos idées commerciales et requêtes de niche soumises sont traitées de manière strictement confidentielle. Elles ne sont pas partagées avec des tiers, pas utilisées à des fins de formation et peuvent être complètement supprimées sur demande. Vos idées vous appartiennent.',
  'legal.privacy.section6.title': '6. Vos droits',
  'legal.privacy.section6.content':
    'Vous disposez des droits suivants concernant vos données personnelles :',
  'legal.privacy.section6.item1': "Droit d'accès aux données stockées",
  'legal.privacy.section6.item2': 'Droit de rectification des données inexactes',
  'legal.privacy.section6.item3': "Droit à l'effacement de vos données",
  'legal.privacy.section6.item4': 'Droit à la portabilité des données',
  'legal.privacy.section7.title': '7. Cookies',
  'legal.privacy.section7.content':
    'Notre site web utilise uniquement des cookies techniquement nécessaires à l\'authentification et à la gestion de session. Nous n\'utilisons pas de cookies de suivi ni d\'outils d\'analyse tiers sans votre consentement explicite.',
  'legal.privacy.section8.title': '8. Modifications de cette politique de confidentialité',
  'legal.privacy.section8.content':
    'Nous nous réservons le droit d\'adapter cette politique de confidentialité pour respecter les modifications des exigences légales ou en cas de modifications du service. La version actuelle est toujours disponible sur cette page.',
  'legal.privacy.contact.title': 'Des questions sur la confidentialité ?',
  'legal.privacy.contact.content':
    'Si vous avez des questions sur le traitement de vos données personnelles, veuillez nous contacter à :',

  'auth.passwordStrength.label': 'Force du mot de passe',
  'auth.passwordStrength.weak': 'Faible',
  'auth.passwordStrength.medium': 'Moyen',
  'auth.passwordStrength.strong': 'Fort',
  'auth.passwordStrength.veryStrong': 'Très fort',
  'auth.passwordStrength.minLength': 'Min. 8 caractères',
  'auth.passwordStrength.uppercase': 'Lettre majuscule',
  'auth.passwordStrength.number': 'Chiffre',
  'auth.passwordStrength.special': 'Caractère spécial',

  trial: {
    subtitle: 'Essai gratuit',
    upgrade: 'Passer à l\'offre supérieure',
    creditsRemaining: 'crédits restants',
    inputHint: 'Version d\'essai - Historique des conversations non disponible',
    banner: {
      title: 'Essai de 7 jours actif',
      remaining: '{{days}} jours restants',
      credits: 'crédits disponibles',
      upgradeNow: 'Passer à l\'offre supérieure',
    },
    welcome: {
      title: 'Bienvenue dans l\'essai gratuit !',
      desc: 'Testez notre assistant IA gratuitement pendant 7 jours avec 100 crédits. Posez des questions et découvrez les possibilités !',
    },
    info: {
      title: 'Limitations de l\'essai',
      credits: '100 crédits pour 7 jours',
      noHistory: 'Pas d\'historique des conversations',
      noSettings: 'Fonctionnalités limitées',
      upgrade: 'Passez à l\'offre supérieure pour toutes les fonctionnalités',
    },
  },

  // ─── Settings Page ────────────────────────────────────────────────────────────
  'settings.title': 'Paramètres',
  'settings.subtitle': 'Gérez votre compte et vos préférences',
  'settings.backToOverview': 'Retour à l\'aperçu',
  'settings.subscriptionLink': 'Abonnement et facturation',
  'settings.saved': 'Modifications enregistrées avec succès',
  'settings.changesSaved': 'Modifications enregistrées',
  'settings.saveChanges': 'Enregistrer les modifications',
  'settings.dataExported': 'Données exportées avec succès',

  // Tabs
  'settings.tabs.profile': 'Profil',
  'settings.tabs.preferences': 'Préférences',
  'settings.tabs.notifications': 'Notifications',
  'settings.tabs.account': 'Compte et forfait',

  // Profile
  'settings.profile.changePhoto': 'Changer la photo',
  'settings.profile.photoHint': 'JPG, PNG ou GIF (max. 2 Mo)',
  'settings.profile.uploading': 'Téléchargement...',
  'settings.profile.photoUpdated': 'Photo de profil mise à jour !',
  'settings.profile.name': 'Nom',
  'settings.profile.email': 'E-mail',
  'settings.profile.phone': 'Téléphone',
  'settings.profile.changePassword': 'Changer le mot de passe',
  'settings.profile.currentPassword': 'Mot de passe actuel',
  'settings.profile.newPassword': 'Nouveau mot de passe',
  'settings.profile.confirmPassword': 'Confirmer le mot de passe',

  // Preferences
  'settings.preferences.language': 'Langue',
  'settings.preferences.chooseLanguage': 'Choisir la langue',
  'settings.preferences.timezone': 'Fuseau horaire',
  'settings.preferences.currency': 'Devise',

  // Notifications
  'settings.notifications.emailTitle': 'Notifications par e-mail',
  'settings.notifications.email.analysis': 'Analyse terminée',
  'settings.notifications.email.analysisDesc': 'Recevoir un e-mail lorsque votre analyse est prête',
  'settings.notifications.email.credits': 'Mises à jour des crédits',
  'settings.notifications.email.creditsDesc': 'Notifications concernant les crédits et les réinitialisations',
  'settings.notifications.email.billing': 'Factures et paiements',
  'settings.notifications.email.billingDesc': 'Notifications concernant les factures et les changements de forfait',
  'settings.notifications.email.newsletter': 'Newsletter',
  'settings.notifications.email.newsletterDesc': 'Conseils, mises à jour et nouvelles fonctionnalités',
  'settings.notifications.pushTitle': 'Notifications push',
  'settings.notifications.push.analysis': 'Analyse terminée',
  'settings.notifications.push.analysisDesc': 'Notification dans le navigateur lorsque l\'analyse est prête',
  'settings.notifications.push.credits': 'Alertes de crédits',
  'settings.notifications.push.creditsDesc': 'Alerte lorsque le solde de crédits est faible',

  // Account
  'settings.account.currentSubscription': 'Abonnement actuel',
  'settings.account.plan': 'Forfait',
  'settings.account.price': 'Prix',
  'settings.account.nextBilling': 'Prochaine facturation',
  'settings.account.manageSubscription': 'Gérer l\'abonnement et les paiements',
  'settings.account.dataPrivacy': 'Données et confidentialité',
  'settings.account.exportData': 'Exporter les données',
  'settings.account.deleteAccount': 'Supprimer le compte',

  // Delete Modal
  'settings.deleteModal.title': 'Supprimer le compte ?',
  'settings.deleteModal.subtitle': 'Toutes les données seront définitivement supprimées.',
  'settings.deleteModal.warning1': 'Toutes les analyses et données seront supprimées',
  'settings.deleteModal.warning2': 'L\'abonnement actif sera immédiatement résilié',
  'settings.deleteModal.warning3': 'Aucun remboursement possible',
  'settings.deleteModal.confirmLabel': 'Tapez "{{word}}" pour confirmer *',
  'settings.deleteModal.cancel': 'Annuler',
  'settings.deleteModal.confirm': 'Supprimer le compte',

  // ─── Subscription & Billing ─────────────────────────────
  'sub.backToOverview': 'Retour à l\'aperçu',
  'sub.settings': 'Paramètres',
  'sub.title': 'Abonnement et facturation',
  'sub.subtitle': 'Gérez votre abonnement, vos moyens de paiement et vos factures',
  'sub.tab.overview': 'Aperçu',
  'sub.tab.payment': 'Moyens de paiement',
  'sub.tab.billing': 'Adresse de facturation',
  'sub.tab.history': 'Historique des paiements',
  'sub.memberSince': 'Membre depuis',
  'sub.perMonth': 'par mois',
  'sub.baseCHF': '(CHF {{amount}} de base)',
  'sub.nextBilling': 'Prochaine facturation',
  'sub.creditsUsed': 'Crédits utilisés',
  'sub.paymentMethod': 'Moyen de paiement',
  'sub.creditUsage': 'Utilisation des crédits',
  'sub.changePlan': 'Changer de forfait',
  'sub.reactivate': 'Réactiver',
  'sub.cancelSub': 'Résilier l\'abonnement',
  'sub.manageCards': 'Gérer les cartes',
  'sub.downloadInvoices': 'Télécharger les factures',
  'sub.invoicesAvailable': '{{count}} factures disponibles au format PDF',
  'sub.accountSettings': 'Paramètres du compte',
  'sub.profileNotifications': 'Profil, notifications et plus',
  // Prices in EUR info
  'sub.eurInfo': 'Prix affichés en',
  'sub.eurLabel': 'Euro',
  'sub.eurRate': 'Taux :',
  'sub.currentRate': 'Taux actuel',
  // Payment Methods
  'sub.savedCards': 'Cartes enregistrées',
  'sub.newCard': 'Nouvelle carte',
  'sub.default': 'Par défaut',
  'sub.setDefault': 'Définir par défaut',
  'sub.validUntil': 'Valable jusqu\'au',
  'sub.noCards': 'Aucune carte enregistrée',
  'sub.addFirstCard': 'Ajouter une première carte',
  'sub.securePayments': 'Paiements sécurisés',
  'sub.securePaymentsDesc': 'Toutes les données de paiement sont transmises de manière cryptée et stockées en toute sécurité avec notre prestataire de paiement. Nous ne stockons pas les numéros de carte complets.',
  // Billing Address
  'sub.billingAddress': 'Adresse de facturation',
  'sub.edit': 'Modifier',
  'sub.name': 'Nom',
  'sub.streetAddress': 'Rue et numéro',
  'sub.zip': 'Code postal',
  'sub.city': 'Ville',
  'sub.country': 'Pays',
  'sub.address': 'Adresse',
  'sub.save': 'Enregistrer',
  'sub.cancel': 'Annuler',
  'sub.country.switzerland': 'Suisse',
  'sub.country.germany': 'Allemagne',
  'sub.country.austria': 'Autriche',
  'sub.country.netherlands': 'Pays-Bas',
  'sub.country.belgium': 'Belgique',
  // Payment History
  'sub.paymentHistory': 'Historique des paiements',
  'sub.allInvoicesPDF': 'Télécharger toutes les factures au format PDF avec logo',
  'sub.downloadAll': 'Tout télécharger',
  'sub.eurInvoiceNote': 'Les factures sont toujours émises en CHF. Les montants en EUR sont fournis à titre indicatif uniquement.',
  'sub.date': 'Date',
  'sub.description': 'Description',
  'sub.net': 'Net',
  'sub.vat': 'TVA',
  'sub.total': 'Total',
  'sub.status': 'Statut',
  'sub.pdf': 'PDF',
  'sub.invoices': 'factures',
  'sub.totalAmount': 'Montant total',
  // Change Plan Modal
  'sub.changePlanTitle': 'Changer de forfait',
  'sub.current': 'Actuel',
  'sub.month': '/mois',
  'sub.showLess': 'Afficher moins',
  'sub.showMore': '+{{count}} de plus',
  'sub.switchPlan': 'Changer de forfait',
  'sub.eurPriceNote': 'Prix affichés en EUR ({{note}}). La facturation est en CHF.',
  // Cancel Modal
  'sub.cancelTitle': 'Vraiment résilier l\'abonnement ?',
  'sub.cancelIrreversible': 'Cette action est irréversible.',
  'sub.cancelWarning1': 'Tous les crédits restants expireront',
  'sub.cancelWarning2': 'Passer au forfait gratuit',
  'sub.cancelWarning3': 'Perte de toutes les fonctionnalités premium',
  'sub.pauseInstead': 'Alternative : Suspendre l\'abonnement ?',
  'sub.pauseDesc': 'Suspendre votre abonnement et conserver vos données.',
  'sub.preferPause': 'Préférer suspendre',
  'sub.cancelReason': 'Raison de la résiliation',
  'sub.selectReason': 'Veuillez sélectionner...',
  'sub.reason.tooExpensive': 'Trop cher',
  'sub.reason.notUsing': 'Pas assez utilisé',
  'sub.reason.missingFeatures': 'Fonctionnalités manquantes',
  'sub.reason.foundAlternative': 'Alternative trouvée',
  'sub.reason.other': 'Autre',
  'sub.confirmType': 'Confirmation : Tapez "CANCEL" *',
  'sub.cancelNow': 'Résilier maintenant',
  // Add Card Modal
  'sub.addCardTitle': 'Ajouter une nouvelle carte',
  'sub.cardHolder': 'Titulaire de la carte *',
  'sub.cardNumber': 'Numéro de carte *',
  'sub.expiryDate': 'Date d\'expiration *',
  'sub.addCard': 'Ajouter la carte',
  // Change Card Modal
  'sub.choosePayment': 'Choisir le moyen de paiement',
  'sub.active': 'Actif',
  'sub.close': 'Fermer',
  // Toast messages
  'sub.toast.cancelled': 'Votre abonnement a été résilié à la fin de la période de facturation.',
  'sub.toast.reactivated': 'Votre abonnement a été réactivé avec succès !',
  'sub.toast.planChanged': 'Forfait changé avec succès pour {{plan}} !',
  'sub.toast.defaultChanged': 'Moyen de paiement par défaut modifié.',
  'sub.toast.cannotDeleteDefault': 'La carte par défaut ne peut pas être supprimée.',
  'sub.toast.cardRemoved': 'La carte a été supprimée.',
  'sub.toast.fillAll': 'Veuillez remplir tous les champs.',
  'sub.toast.cardAdded': 'Nouvelle carte ajoutée avec succès !',
  'sub.toast.billingSaved': 'Adresse de facturation enregistrée.',
  'sub.toast.invoiceDownloaded': 'Facture {{id}} téléchargée !',
  'sub.toast.pdfError': 'Erreur lors de la création du PDF.',
  // Chat interface
  'sub.notEnoughCredits': 'Crédits insuffisants',
  'sub.needCredits': 'Vous avez besoin d\'au moins {{count}} crédits par question.',
  'sub.creditsLow': 'Crédits bientôt épuisés',
  'sub.questionsLeft': '{{count}} questions possibles.',
  'sub.plan': 'Forfait',
  'sub.base': 'de base',
  'sub.unlimited': 'Illimité',
  'sub.status.active': 'Actif',
  'sub.status.cancelled': 'Résilié',
  'sub.status.paused': 'Suspendu',
  'sub.invoice': 'FACTURE',
  'sub.from': 'DE',
  'sub.to': 'À',
  'sub.vatId': 'N° TVA',
  'sub.tel': 'Tél',
  'sub.invoiceDate': 'Date de la facture',
  'sub.invoiceNumber': 'Numéro de facture',
  'sub.paymentStatus': 'Statut du paiement',
  'sub.creditCard': 'Carte de crédit',
  'sub.quantity': 'QTÉ',
  'sub.price': 'PRIX',
  'sub.amount': 'MONTANT',
  'sub.subtotal': 'Sous-total',
  'sub.bank': 'Banque',
  'sub.card': 'Carte',
  'sub.cvc': 'CVC',
  'sub.cardHolderPlaceholder': 'Jean Dupont',

  // ─── Admin Panel ─────────────────────────────────────────────────────────────
  'admin.title': 'Tableau de bord admin',
  'admin.subtitle': 'Centre de contrôle',
  'admin.superAdmin': 'Super administrateur',
  'admin.logout': 'Déconnexion',
  'admin.tabs.users': 'Gestion des utilisateurs',
  'admin.tabs.downgrades': 'Rétrogradations',
  'admin.tabs.tips': 'Conseil du jour',
  'admin.tabs.coupons': 'Codes promo',
  'admin.tabs.website': 'Éditeur du site web',
  'admin.tabs.ai': 'Paramètres IA',
  'admin.tabs.transactions': 'Journal des transactions',
  'admin.tabs.stats': 'Statistiques',
  'admin.users.searchPlaceholder': 'Rechercher des utilisateurs (e-mail ou nom)...',
  'admin.users.manageSubscription': 'Gérer l\'abonnement',
  'admin.users.grantFree': 'Offrir un compte gratuit',
  'admin.users.blockUser': 'Bloquer l\'utilisateur',
  'admin.users.cancellationPlaceholder': 'Pourquoi l\'abonnement est-il résilié ?',
  'admin.users.selectPlan': 'Sélectionner un forfait',
  'admin.users.subChanged': 'Abonnement de {{name}} changé pour {{plan}}',
  'admin.users.noReasonGiven': 'Aucune raison donnée',
  'admin.users.subCancelled': 'Abonnement de {{name}} résilié (valable jusqu\'au {{date}})',
  'admin.users.paused': 'Suspendu',
  'admin.users.subPaused': 'L\'abonnement de {{name}} a été suspendu',
  'admin.users.subReactivated': 'L\'abonnement de {{name}} a été réactivé',
  'admin.users.freeAccount': 'Compte gratuit',
  'admin.users.blocked': 'Bloqué',
  'admin.users.cancelledExpiring': 'Résilié (bientôt expiré)',
  'admin.users.cancelledOn': 'Résilié le :',
  'admin.users.endsOn': 'Expire le :',
  'admin.users.daysRemaining': 'jours restants',
  'admin.users.expired': '(Expiré)',
  'admin.users.total': 'Total :',
  'admin.users.usersLabel': 'utilisateurs',
  'admin.users.free': 'gratuit',
  'admin.users.block': 'Bloquer',
  'admin.users.unblock': 'Débloquer',
  'admin.users.unblockUser': 'Débloquer l\'utilisateur',
  'admin.users.selectAction': 'Sélectionner une action',
  'admin.users.cancelSub': 'Résilier l\'abonnement',
  'admin.users.cancelSubDesc': 'Résiliation en fin de mois',
  'admin.users.pauseSub': 'Suspendre l\'abonnement',
  'admin.users.pauseSubDesc': 'Suspension temporaire',
  'admin.users.changePlan': 'Changer de forfait',
  'admin.users.changePlanDesc': 'Passer à un autre forfait',
  'admin.users.reactivateSub': 'Réactiver l\'abonnement',
  'admin.users.reactivateDesc': 'Annuler la résiliation',
  'admin.users.alreadyCancelled': 'Abonnement déjà résilié',
  'admin.users.planLabel': 'Forfait',
  'admin.users.cancellationReasonOpt': 'Raison de la résiliation (optionnelle)',
  'admin.users.cancelInfo1': 'L\'abonnement prendra fin le',
  'admin.users.cancelInfo2': '(fin du mois). Jusque-là, l\'utilisateur a un accès complet. Pas de remboursement.',
  'admin.users.newPlan': 'Nouveau forfait',
  'admin.users.warning': 'Attention',
  'admin.users.blockDesc': 'L\'utilisateur sera immédiatement déconnecté et ne pourra plus se reconnecter. Toutes les sessions actives seront terminées.',
  'admin.users.confirmUnblock': 'Confirmer le déblocage',
  'admin.users.unblockDesc': 'L\'utilisateur peut à nouveau se connecter et utiliser toutes les fonctionnalités.',
  'admin.users.afterBlock': 'Après blocage :',
  'admin.users.afterUnblock': 'Après déblocage :',
  'admin.users.noAccountAccess': 'Aucun accès au compte',
  'admin.users.noNewAnalyses': 'Aucune nouvelle analyse possible',
  'admin.users.creditsStored': 'Les crédits et l\'historique restent stockés',
  'admin.users.accessRestored': 'Accès au compte restauré',
  'admin.users.allFeaturesAvail': 'Toutes les fonctionnalités à nouveau disponibles',
  'admin.users.creditsPreserved': 'Crédits et historique conservés',
  'admin.users.downgrade': 'Rétrograder le forfait',
  'admin.users.grantFreeBtn': 'Offrir gratuitement',
  'admin.users.durationMonths': 'Durée (mois)',
  'admin.users.months': 'mois',
  'admin.users.freePlan': 'gratuit',
  'admin.users.freeSummary': 'reçoit',
  'admin.users.withCredits': 'avec',
  'admin.users.credits': 'Crédits',
  'admin.users.subInfo': 'Informations sur l\'abonnement',
  'admin.users.currentPlan': 'Forfait actuel',
  'admin.users.joined': 'Inscrit le',
  'admin.users.totalSpent': 'Dépenses totales',
  'admin.users.paymentMethod': 'Moyen de paiement',
  'admin.users.validThrough': 'Valable jusqu\'au',
  'admin.users.billingAddress': 'Adresse de facturation',
  'admin.users.transactionHistory': 'Historique des transactions',
  'admin.users.cancellationDate': 'Date de résiliation',
  'admin.users.validUntil': 'Valable jusqu\'au (fin de mois)',
  'admin.users.cancellationReason': 'Raison de la résiliation',
  'admin.users.noReason': 'Aucune raison donnée',
  'admin.users.timeRemaining': 'Temps restant',
  'admin.users.daysUntilDeactivation': 'jours avant désactivation',
  'admin.table.user': 'Utilisateur',
  'admin.table.plan': 'Forfait',
  'admin.table.subStatus': 'Statut de l\'abonnement',
  'admin.table.cancellation': 'Résiliation',
  'admin.table.payment': 'Moyen de paiement',
  'admin.table.spending': 'Dépenses',
  'admin.table.actions': 'Actions',
  'admin.actions.viewDetails': 'Voir les détails',
  'admin.actions.manageSubscription': 'Gérer l\'abonnement',
  'admin.actions.grantFree': 'Offrir un accès gratuit',
  'admin.actions.block': 'Bloquer l\'utilisateur',
  'admin.actions.unblock': 'Débloquer l\'utilisateur',
  'admin.actions.cancel': 'Annuler',
  'admin.actions.save': 'Enregistrer',
  'admin.actions.delete': 'Supprimer',
  'admin.actions.confirm': 'Confirmer',
  'admin.actions.done': 'Terminé',
  'admin.actions.edit': 'Modifier',
  'admin.actions.close': 'Fermer',
  'admin.table.status': 'Statut',
  'admin.filter.all': 'Tous',
  'admin.subscription.active': 'Actif',
  'admin.subscription.cancelled': 'Résilié',
  'admin.subscription.paused': 'Suspendu',
  'admin.subscription.unknown': 'Inconnu',
  'admin.status.active': 'Actif',
  'admin.status.inactive': 'Inactif',
  'admin.status.pending': 'En attente',
  'admin.status.approved': 'Approuvé',
  'admin.status.rejected': 'Rejeté',
  'admin.coupons.title': 'Gestion des coupons',
  'admin.coupons.subtitle': 'Créer et gérer les codes promo',
  'admin.coupons.newCoupon': 'Nouveau coupon',
  'admin.coupons.registrationCoupons': 'Coupons d\'inscription',
  'admin.coupons.trialCoupons': 'Coupons d\'essai',
  'admin.coupons.type': 'Type',
  'admin.coupons.plan': 'Forfait',
  'admin.coupons.value': 'Valeur',
  'admin.coupons.usage': 'Utilisation',
  'admin.coupons.validUntil': 'Valable jusqu\'au',
  'admin.coupons.created': 'Créé le',
  'admin.coupons.actions': 'Actions',
  'admin.coupons.copyCode': 'Copier le code',
  'admin.coupons.allPlans': 'Tous les forfaits',
  'admin.coupons.discount': 'Réduction',
  'admin.coupons.days': 'jours',
  'admin.coupons.months': 'mois',
  'admin.coupons.free': 'gratuit',
  'admin.coupons.unlimited': 'Illimité',
  'admin.coupons.createRegistration': 'Créer un coupon d\'inscription',
  'admin.coupons.createTrial': 'Créer un coupon d\'essai',
  'admin.coupons.couponCode': 'Code promo',
  'admin.coupons.codePlaceholder': 'ex. NF-7X3K9M',
  'admin.coupons.generateCode': 'Générer un nouveau code',
  'admin.coupons.alertFillRequired': 'Veuillez remplir tous les champs requis',
  'admin.coupons.alertSelectExpiry': 'Veuillez sélectionner une date d\'expiration ou activer "Validité illimitée"',
  'admin.coupons.alertCreateError': 'Erreur lors de la création du coupon',
  'admin.coupons.confirmDelete': 'Êtes-vous sûr de vouloir supprimer ce coupon ?',
  'admin.coupons.discountPercent': 'Réduction (%)',
  'admin.coupons.bonusCredits': 'Crédits bonus',
  'admin.coupons.freeDuration': 'Durée gratuite',
  'admin.coupons.maxUses': 'Utilisations max',
  'admin.coupons.expiryDate': 'Date d\'expiration',
  'admin.coupons.unlimitedValidity': 'Validité illimitée',
  'admin.coupons.unlimitedUses': 'Utilisations illimitées',
  'admin.coupons.trialCredits': 'Crédits d\'essai',
  'admin.coupons.trialDuration': 'Durée de l\'essai',
  'admin.coupons.typePlaceholder': 'ex. Early Bird, Partenaire, Influenceur',
  'admin.coupons.duration': 'Durée',
  'admin.stats.totalUsers': 'Nombre total d\'utilisateurs',
  'admin.stats.monthlyRevenue': 'Revenus mensuels',
  'admin.stats.activeSubscriptions': 'Abonnements actifs',
  'admin.stats.average': 'Moyenne',
  'admin.stats.revenuePerUser': 'Revenus par utilisateur',
  'admin.stats.grossRevenue': 'Revenus bruts',
  'admin.stats.net': 'NET',
  'admin.stats.netRevenue': 'Revenus nets',
  'admin.stats.churnRate': 'Taux de désabonnement',
  'admin.stats.planDistribution': 'Répartition des forfaits',
  'admin.stats.users': 'utilisateurs',
  'admin.stats.revenueByPlan': 'Revenus par forfait',
  'admin.stats.recentActivity': 'Activité récente',
  'admin.stats.activity1': 'Thomas Weber est passé au forfait Builder',
  'admin.stats.activity2': 'Nouvel utilisateur inscrit',
  'admin.stats.activity3': 'Anna Schmidt est passée au forfait Pro',
  'admin.stats.hoursAgo2': 'il y a 2 heures',
  'admin.stats.hoursAgo5': 'il y a 5 heures',
  'admin.stats.dayAgo1': 'il y a 1 jour',
  'admin.stats.couponStats': 'Statistiques des coupons',
  'admin.stats.totalRedemptions': 'Nombre total d\'utilisations',
  'admin.stats.activeCoupons': 'Coupons actifs',
  'admin.stats.registrationRedemptions': 'Utilisations des coupons d\'inscription',
  'admin.stats.trialRedemptions': 'Utilisations des coupons d\'essai',
  'admin.stats.couponDistribution': 'Répartition des coupons',
  'admin.stats.registrationCoupons': 'Coupons d\'inscription',
  'admin.stats.trialCoupons': 'Coupons d\'essai',
  'admin.stats.expiredInactive': 'Expirés/Inactifs',
  'admin.stats.topCoupons': 'Meilleurs coupons par utilisations',
  'admin.stats.redemptions': 'utilisations',
  'admin.stats.noCouponsRedeemed': 'Aucun coupon utilisé pour le moment',
  'admin.downgrade.pending': 'en attente',
  'admin.downgrade.refunds': 'Remboursements',
  'admin.downgrade.sectionRequests': 'Demandes',
  'admin.downgrade.sectionStats': 'Statistiques',
  'admin.downgrade.sectionRules': 'Règles',
  'admin.downgrade.pendingRequests': 'Demandes en attente',
  'admin.downgrade.approvedRequests': 'Demandes approuvées',
  'admin.downgrade.rejectedRequests': 'Demandes rejetées',
  'admin.downgrade.activeRules': 'Règles actives',
  'admin.downgrade.autoRules': 'Règles de rétrogradation automatique',
  'admin.downgrade.autoRulesDesc': 'Créez des règles qui déclenchent automatiquement des rétrogradations en fonction du comportement d\'utilisation',
  'admin.downgrade.newRule': 'Nouvelle règle',
  'admin.downgrade.totalRules': 'Nombre total de règles',
  'admin.downgrade.triggeredActions': 'Actions déclenchées',
  'admin.downgrade.conditionsAnd': 'Conditions (liées par ET)',
  'admin.downgrade.action': 'Action',
  'admin.downgrade.successTitle': 'Rétrogradation réussie !',
  'admin.downgrade.successDesc': 'L\'utilisateur a été rétrogradé avec succès et le remboursement a été traité.',
  'admin.downgrade.closing': 'Fermeture...',
  'admin.downgrade.title': 'Rétrograder l\'utilisateur',
  'admin.downgrade.currentPlan': 'Forfait actuel',
  'admin.downgrade.spending': 'Dépenses',
  'admin.downgrade.availablePlans': 'Forfaits disponibles pour la rétrogradation',
  'admin.downgrade.perMonth': 'par mois',
  'admin.downgrade.refundCalc': 'Calcul du remboursement',
  'admin.downgrade.currentPlanLabel': 'Forfait actuel',
  'admin.downgrade.newPlan': 'Nouveau forfait',
  'admin.downgrade.remainingDays': 'Jours restants',
  'admin.downgrade.daysOf': '15 sur 30 jours',
  'admin.downgrade.proRataRefund': 'Remboursement proportionnel',
  'admin.downgrade.importantNote': 'Note importante',
  'admin.downgrade.warningDesc': 'La rétrogradation sera exécutée immédiatement. L\'utilisateur perdra l\'accès aux fonctionnalités premium et les crédits excédentaires seront supprimés.',
  'admin.downgrade.processing': 'Traitement...',
  'admin.downgrade.execute': 'Exécuter la rétrogradation',
  'admin.downgrade.notification': 'Notification',
  'admin.downgrade.noNotification': 'Aucune notification',
  'admin.downgrade.daysPeriod': 'jours de grâce',
  'admin.downgrade.created': 'Créé le :',
  'admin.downgrade.triggered': 'déclenché',
  'admin.downgrade.noRules': 'Aucune règle créée pour le moment',
  'admin.downgrade.createFirstRule': 'Créer une première règle',
  'admin.downgrade.editRule': 'Modifier la règle',
  'admin.downgrade.createRule': 'Créer une nouvelle règle',
  'admin.downgrade.ruleName': 'Nom de la règle',
  'admin.downgrade.description': 'Description',
  'admin.downgrade.allConditions': 'Conditions (toutes doivent être remplies)',
  'admin.downgrade.addCondition': 'Ajouter une condition',
  'admin.downgrade.type': 'Type',
  'admin.downgrade.value': 'Valeur',
  'admin.downgrade.fromPlan': 'Depuis le forfait',
  'admin.downgrade.toPlan': 'Vers le forfait',
  'admin.condition.inactivity': 'Inactivité',
  'admin.condition.creditUsage': 'Utilisation des crédits',
  'admin.condition.loginFrequency': 'Fréquence de connexion',
  'admin.condition.featureUsage': 'Utilisation des fonctionnalités',
  'admin.condition.supportTickets': 'Tickets de support',
  'admin.operator.lessThan': 'inférieur à',
  'admin.operator.greaterThan': 'supérieur à',
  'admin.operator.equals': 'exactement',
  'admin.operator.between': 'entre',
  'admin.unit.days': 'jours',
  'admin.unit.perMonth': 'par mois',
  'admin.unit.count': 'nombre',
  'admin.transactions.all': 'Toutes les transactions',
  'admin.transactions.allCards': 'Toutes les cartes',
  'admin.transactions.notFound': 'Aucune transaction trouvée',
  'admin.transactions.totalLabel': 'Total',
  'admin.transactions.transactions': 'transactions',
  'admin.tips.title': 'Conseil du jour',
  'admin.tips.subtitle': 'Créez et gérez les conseils affichés à tous les utilisateurs',
  'admin.tips.active': 'Actif',
  'admin.tips.currentlyShown': 'Ce conseil est actuellement affiché à tous les utilisateurs',
  'admin.tips.createNew': 'Créer un nouveau conseil',
  'admin.tips.generating': 'Génération...',
  'admin.tips.generateAI': 'Générer un conseil par IA',
  'admin.tips.titleLabel': 'Titre',
  'admin.tips.titlePlaceholder': 'ex. Conseil du jour',
  'admin.tips.category': 'Catégorie',
  'admin.tips.categoryTip': 'Conseil',
  'admin.tips.categoryFeature': 'Nouvelle fonctionnalité',
  'admin.tips.categoryProductivity': 'Productivité',
  'admin.tips.categoryUpdate': 'Mise à jour',
  'admin.tips.content': 'Contenu',
  'admin.tips.contentPlaceholder': 'Rédigez votre conseil pour les utilisateurs ici...',
  'admin.tips.addTip': 'Ajouter un conseil',
  'admin.tips.allTips': 'Tous les conseils',
  'admin.tips.noTips': 'Aucun conseil créé pour le moment',
  'admin.tips.noTipsHint': 'Cliquez sur "Générer un conseil par IA" pour commencer',
  'admin.noData': 'Aucune donnée disponible',
  'admin.range.7d': '7 jours',
  'admin.range.30d': '30 jours',
  'admin.range.90d': '90 jours',
  'admin.range.1y': '1 an',
  'admin.actions.saveSettings': 'Enregistrer les paramètres',
  'admin.actions.create': 'Créer',
  'admin.downgrade.sectionReports': 'Rapports',
  'admin.downgrade.settings': 'Paramètres de rétrogradation',
  'admin.downgrade.autoApprove': 'Approbation automatique',
  'admin.downgrade.autoApproveDesc': 'Approuver automatiquement les demandes de rétrogradation',
  'admin.downgrade.refundPolicy': 'Politique de remboursement',
  'admin.downgrade.prorata': 'Remboursement proportionnel',
  'admin.downgrade.prorataDesc': 'Remboursement proportionnel basé sur les jours restants',
  'admin.downgrade.fullRefund': 'Remboursement complet',
  'admin.downgrade.fullRefundDesc': 'Remboursement complet de la différence de prix',
  'admin.downgrade.noRefund': 'Aucun remboursement',
  'admin.downgrade.noRefundDesc': 'Rétrogradation sans remboursement',
  'admin.downgrade.daysRemaining15': '(avec 15 jours restants)',
  'admin.downgrade.requestsTitle': 'Demandes de rétrogradation',
  'admin.downgrade.approvalRate': "Taux d'approbation",
  'admin.downgrade.mostCommonTransition': 'Transition la plus courante',
  'admin.downgrade.mostCommonReason': 'Raison la plus courante',
  'admin.downgrade.avgProcessingTime': 'Délai de traitement moyen',
  'admin.downgrade.avgTimeDesc': 'Délai moyen jusqu\'à la décision',
  'admin.downgrade.totalRefunds': 'Total des remboursements',
  'admin.downgrade.pendingRefunds': 'Remboursements en attente',
  'admin.downgrade.summary': 'Résumé',
  'admin.downgrade.total': 'Total',
  'admin.downgrade.csvDesc': 'Pour Excel, Google Sheets',
  'admin.downgrade.downloadCSV': 'Télécharger au format CSV',
  'admin.downgrade.jsonDesc': 'Pour les développeurs, les API',
  'admin.downgrade.downloadJSON': 'Télécharger au format JSON',
  'admin.downgrade.exportInfo': "L'export contient",
  'admin.downgrade.entries': 'entrées de la période sélectionnée',
  'admin.downgrade.topReasons': 'Raisons de rétrogradation les plus courantes',
  'admin.downgrade.refundHistory': 'Historique des remboursements',
  'admin.downgrade.noRefunds': 'Aucun remboursement pour le moment',
  'admin.downgrade.statistics': 'Statistiques de rétrogradation',
  'admin.downgrade.requests': 'Demandes',
  'admin.downgrade.monthlyTrend': 'Tendance mensuelle',
  'admin.downgrade.planTransitions': 'Transitions de forfaits',
  'admin.downgrade.trend': 'Tendance (vs mois précédent)',
  'admin.downgrade.trendDesc': 'Moins de rétrogradations = mieux',
  'admin.coupons.allPlansUniversal': 'Tous les forfaits (Universel)',
  'admin.coupons.onlyStarter': 'Starter uniquement',
  'admin.coupons.onlyPro': 'Pro uniquement',
  'admin.coupons.onlyBuilder': 'Builder uniquement',
  'admin.coupons.allPlansHint': 'Choisissez "Tous les forfaits" pour un coupon universel',
  'admin.coupons.discountOptional': 'Réduction % (optionnelle)',
  'admin.coupons.discountPlaceholder': 'ex. 50 pour 50% de réduction',
  'admin.coupons.bonusCreditsOptional': 'Crédits bonus (optionnels)',
  'admin.coupons.bonusCreditsPlaceholder': 'ex. 500',
  'admin.coupons.freeDurationOptional': 'Durée gratuite (optionnelle)',
  'admin.coupons.durationPlaceholder': 'ex. 30',
  'admin.coupons.freeDurationHint': 'ex. 30 jours d\'utilisation gratuite',
  'admin.coupons.noLimit': 'Pas de limitation d\'utilisation',
  'admin.coupons.noExpiry': 'Pas de date d\'expiration',
  'admin.coupons.creditsPlaceholder': 'ex. 100',
  'admin.coupons.creditsHint': 'Nombre de crédits pour l\'accès d\'essai',
  'admin.coupons.trialDurationHint': 'Durée de validité de l\'accès d\'essai',
  'admin.coupons.autoCalculated': 'Calculé automatiquement à partir de la durée d\'essai',
  'admin.websiteEditor.title': 'Éditeur du site web',
  'admin.websiteEditor.subtitle': 'Modifiez toutes les sections de la page d\'accueil',
  'admin.websiteEditor.openPreview': 'Ouvrir l\'aperçu',
  'admin.websiteEditor.group.structure': 'Structure de la page',
  'admin.websiteEditor.group.design': 'Design et mise en page',
  'admin.websiteEditor.group.settings': 'Paramètres',
  'admin.websiteEditor.tab.navbar': 'Navigation',
  'admin.websiteEditor.tab.howitworks': 'Comment ça marche',
  'admin.websiteEditor.tab.about': 'À propos',
  'admin.websiteEditor.tab.pricing': 'Tarifs',
  'admin.websiteEditor.tab.sections': 'Sections',
  'admin.websiteEditor.tab.media': 'Médias',
  'admin.websiteEditor.tab.chatwidget': 'Discutez avec nous',
  'admin.websiteEditor.tab.invoice': 'Factures',
  'admin.websiteEditor.tab.legal': 'Mentions légales',
  'admin.websiteEditor.tab.seo': 'SEO de base',
  'admin.websiteEditor.tab.advancedseo': 'SEO avancé',
  'admin.websiteEditor.tab.versions': 'Versions',
  'admin.hero.title': 'Modifier la section Hero',
  'admin.hero.subtitle': 'Textes, boutons et statistiques de la page d\'accueil',
  'admin.hero.reset': 'Réinitialiser',
  'admin.hero.save': 'Enregistrer',
  'admin.hero.savedMsg': 'Données Hero enregistrées !',
  'admin.hero.badge': 'Texte du badge',
  'admin.hero.headings': 'Titres',
  'admin.hero.line1White': 'Ligne 1 (blanche)',
  'admin.hero.line2Gold': 'Ligne 2 (dorée)',
  'admin.hero.subtitleSection': 'Sous-titre',
  'admin.hero.line1': 'Ligne 1',
  'admin.hero.line2': 'Ligne 2',
  'admin.hero.buttons': 'Boutons',
  'admin.hero.primaryBtn': 'Bouton principal (doré)',
  'admin.hero.secondaryBtn': 'Bouton secondaire (bordure)',
  'admin.hero.stats': 'Statistiques',
  'admin.hero.statN': 'Statistique {{n}}',
  'admin.hero.value': 'Valeur',
  'admin.hero.label': 'Libellé',
  'admin.hero.previewNote': 'Les modifications seront visibles sur la page d\'accueil après l\'enregistrement. Rechargez la page pour voir l\'aperçu.',

  // Idea History
  'history.title': 'Historique des idées',
  'history.countLabel': '{{count}} analyses',
  'history.recentLabel': 'Vos analyses récentes',
  'history.exportAll': 'Tout exporter',
  'history.metrics.marketSize': 'Taille du marché',
  'history.metrics.competition': 'Concurrence',
  'history.metrics.startingCapital': 'Capital de départ',
  'history.metrics.timeToMarket': 'Délai de mise sur le marché',
  'history.metrics.profitPotential': 'Potentiel de profit',
  'history.metrics.scalability': 'Évolutivité',
  'history.summary.title': 'Résumé',
  'history.download': 'Télécharger',
  'history.downloadJSON': 'Enregistrer en JSON',
  'history.downloadTXT': 'Enregistrer en TXT',
  'history.downloadPDF': 'Enregistrer en PDF',
  'history.fullAnalysis': 'Analyse complète',
  'history.searchPlaceholder': 'Rechercher par titre ou tags...',
  'history.filterAll': 'Toutes les évaluations',
  'history.loading': 'Chargement des analyses...',
  'history.noResults': 'Aucun résultat trouvé',
  'history.empty': 'Aucune analyse pour le moment',
  'history.emptyHint': 'Commencez une analyse dans l\'Assistant IA',
  'history.delete': 'Supprimer',
  'history.cancel': 'Annuler',
  'history.deleteModalTitle': 'Supprimer l\'analyse ?',
  'history.deleteModalDesc': '"{{title}}" sera définitivement supprimée.',
  'history.errorLoading': 'Erreur lors du chargement des analyses',
  'history.deleteSuccess': 'Analyse supprimée avec succès',
  'history.deleteError': 'Erreur lors de la suppression de l\'analyse',
  'history.jsonExported': 'JSON exporté',
  'history.txtExported': 'TXT exporté',
  'history.allExported': '{{count}} idées exportées',
  'history.analysisHeader': 'ANALYSE D\'IDÉE',
  'history.titleLabel': 'Titre',
  'history.ratingLabel': 'Évaluation',
  'history.dateLabel': 'Date',
  'history.creditsLabel': 'Crédits',
  'history.analysisSection': 'Analyse',

  // Overview
  'overview.title': 'Aperçu',
  'overview.last24h': 'Dernières 24 heures',
  'overview.analysesToday': 'Analyses aujourd\'hui',
  'overview.totalAnalyses': 'Analyses totales',
  'overview.successRate': 'Taux de succès',
  'overview.topRatings': 'Meilleures évaluations',
  'overview.recentActivity': 'Activité récente',
  'overview.viewAll': 'Voir tout',
  'overview.quickAccess': 'Accès rapide',
  'overview.quick.newAnalysis': 'Nouvelle analyse',
  'overview.quick.newAnalysisDesc': 'Commencer une nouvelle analyse de niche par IA',
  'overview.quick.myAnalyses': 'Mes analyses',
  'overview.quick.myAnalysesDesc': 'Voir toutes les analyses précédentes',
  'overview.quick.buyCredits': 'Acheter des crédits',
  'overview.quick.buyCreditsDesc': 'Plus de crédits pour plus d\'analyses',
  'overview.quick.settings': 'Paramètres',
  'overview.quick.settingsDesc': 'Personnaliser le profil et les préférences',
  'overview.unlimitedCredits': 'Crédits illimités disponibles',
  'overview.creditsAvailable': 'crédits disponibles',
  'overview.upgradePlan': 'Améliorer le forfait',
  'overview.buyCredits': 'Acheter des crédits',
  'overview.creditUsage': 'Utilisation des crédits ce mois-ci',
  'overview.available': 'disponibles',

  // --- Admin New Keys ---
  'admin.transactions.upgrades': 'Améliorations',
  'admin.transactions.downgrades': 'Rétrogradations',
  'admin.transactions.visa': 'Visa',
  'admin.transactions.mastercard': 'Mastercard',
  'admin.transactions.amex': 'Amex',

  'admin.users.grantFreeSuccess': '{{name}} bénéficie maintenant de {{months}} mois de forfait {{plan}} gratuit',
  'admin.users.blockSuccess': '{{name}} a été bloqué',
  'admin.users.unblockSuccess': '{{name}} a été débloqué',
  'admin.users.removeFreeSuccess': 'Le statut gratuit de {{name}} a été supprimé',

  'admin.downgrade.plans.builder': 'Builder',
  'admin.downgrade.plans.pro': 'Pro',
  'admin.downgrade.plans.starter': 'Starter',
  'admin.downgrade.plans.free': 'Gratuit',

  'admin.unit.percent': '%',

  'admin.tips.discoverNewFeature': 'Découvrir une nouvelle fonctionnalité',
  'admin.tips.productivityBoost': 'Gain de productivité',
  'admin.tips.importantUpdate': 'Mise à jour importante',
  'admin.tips.tipOfDay': 'Conseil du jour',

  'admin.actions.activate': 'Activer',
  'admin.actions.deactivate': 'Désactiver',
  'admin.websiteEditor.tab.features': 'Fonctionnalités',
  'admin.websiteEditor.tab.testimonials': 'Témoignages',
  'admin.websiteEditor.tab.faq': 'FAQ',
  'admin.websiteEditor.tab.cta': 'CTA',
  'admin.websiteEditor.tab.footer': 'Pied de page',
  'admin.websiteEditor.tab.design': 'Design',
  'admin.websiteEditor.tab.customcode': 'Code personnalisé',
  'admin.websiteEditor.tab.socials': 'Médias sociaux',
  'admin.websiteEditor.tab.importexport': 'Import/Export',

  // --- AI Settings Editor ---
  'admin.ai.title': 'Paramètres de l\'assistant IA',
  'admin.ai.subtitle': 'Configurer le comportement, le style et la profondeur d\'analyse',
  'admin.ai.smartWeightingActive': 'Pondération intelligente active',
  'admin.ai.smartWeightingDesc': 'L\'IA combine automatiquement toutes les perspectives avec une pondération intelligente. Avec plusieurs préréglages, le premier est pondéré plus lourdement (préréglage principal). Vous pouvez également ajuster la pondération manuellement.',
  'admin.ai.modelTitle': 'Modèle IA IdeaVerdict',
  'admin.ai.modelSubtitle': 'Choisissez le moteur IA pour toutes les analyses des utilisateurs',
  'admin.ai.activeModel': 'Modèle actif :',
  'admin.ai.activeModelDesc': 'Tous les utilisateurs reçoivent les réponses de ce modèle.',
  'admin.ai.recommendations': 'Recommandations pour des résultats optimaux',
  'admin.ai.new': 'NOUVEAU',
  'admin.ai.recommendationsDesc': 'Combinaisons de préréglages éprouvées pour une qualité d\'analyse optimale',
  'admin.ai.recommendationsInfo': 'Ces combinaisons ont été testées et donnent les meilleurs résultats. Cliquez sur une recommandation pour l\'appliquer directement.',
  'admin.ai.active': 'ACTIF',
  'admin.ai.apply': 'Appliquer',
  'admin.ai.avoid': 'Éviter',
  'admin.ai.excellentQuality': 'Qualité excellente',
  'admin.ai.goodQuality': 'Bonne qualité',
  'admin.ai.poorQuality': 'Qualité diluée - Non recommandé',
  'admin.ai.proTips': 'Conseils Pro',
  'admin.ai.tip1Title': '2 préréglages sont optimaux :',
  'admin.ai.tip1Desc': 'Perspective claire sans dilution',
  'admin.ai.tip2Title': 'Le préréglage principal est important :',
  'admin.ai.tip2Desc': 'Le premier préréglage a la plus grande influence',
  'admin.ai.tip3Title': 'Évitez les opposés :',
  'admin.ai.tip3Desc': '"EXTREME" + "Créatif" = contradictoire',
  'admin.ai.tip4Title': 'Maximum 3 préréglages :',
  'admin.ai.tip4Desc': 'Avec 4 préréglages ou plus, le résultat devient trop général',
  'admin.ai.warningManyPresets': 'Attention : Nombreux préréglages',
  'admin.ai.warningManyPresetsDesc': 'Vous avez sélectionné {{count}} préréglages. Cela peut diluer le résultat.',
  'admin.ai.warningRecommend': 'Recommandé : Maximum 2-3 préréglages',
  'admin.ai.forOptimalResults': 'pour des résultats optimaux.',
  'admin.ai.presets': 'Préréglages',
  'admin.ai.multiSelect': '(sélection multiple possible)',
  'admin.ai.presetsDesc': 'Choisissez un ou plusieurs préréglages. Le premier préréglage est le préréglage principal avec la pondération la plus élevée.',
  'admin.ai.primaryPreset': 'Préréglage principal',
  'admin.ai.weightControl': 'Contrôle de la pondération',
  'admin.ai.weightControlDesc': "Ajustez l'influence de chaque préréglage sur l'analyse",
  'admin.ai.manual': 'Manuel',
  'admin.ai.automatic': 'Automatique',
  'admin.ai.autoWeightingActive': 'Pondération automatique active :',
  'admin.ai.autoWeightingDesc': 'La pondération est automatiquement optimisée en fonction du nombre de préréglages.',
  'admin.ai.primary': 'PRINCIPAL',
  'admin.ai.totalWeight': 'Total',
  'admin.ai.shouldBe100': 'devrait être 100%',
  'admin.ai.normalize': 'Normaliser',
  'admin.ai.combinedSettings': 'Paramètres combinés',
  'admin.ai.presetsCount': 'préréglages',
  'admin.ai.strictness': 'Rigueur',
  'admin.ai.realism': 'Réalisme',
  'admin.ai.creativity': 'Créativité',
  'admin.ai.detailLevel': 'Niveau de détail',
  'admin.ai.customInstructions': 'Instructions personnalisées',
  'admin.ai.customInstructionsDesc': 'Instructions supplémentaires combinées avec les préréglages',
  'admin.ai.customInstructionsPlaceholder': 'ex. "Concentrez-vous sur le marché DACH", "Utilisez toujours des chiffres concrets", "Comparez avec les concurrents existants", "Répondez toujours avec des exemples"...',
  'admin.ai.customInstructionsHint': 'Ces instructions sont automatiquement combinées avec les préréglages sélectionnés.',
  'admin.ai.manualFinetuning': 'Réglage fin manuel',
  'admin.ai.manualFinetuningHint': '(optionnel, remplace les valeurs des préréglages)',
  'admin.ai.manualFinetuningDesc': 'Ajustez manuellement les valeurs combinées si vous souhaitez affiner quelque chose.',
  'admin.ai.tone': 'Ton',
  'admin.ai.mild': 'Doux',
  'admin.ai.strict': 'Strict',
  'admin.ai.creative': 'Créatif',
  'admin.ai.realistic': 'Réaliste',
  'admin.ai.conservative': 'Conservateur',
  'admin.ai.compact': 'Compact',
  'admin.ai.detailed': 'Détaillé',
  'admin.ai.responseLength': 'Longueur de la réponse',
  'admin.ai.short': 'Courte et concise',
  'admin.ai.medium': 'Moyenne',
  'admin.ai.long': 'Détaillée',
  'admin.ai.focusAreas': "Domaines d'analyse prioritaires",
  'admin.ai.autoRating': 'Évaluation automatique',
  'admin.ai.autoRatingDesc': 'Chaque analyse reçoit automatiquement une évaluation (Bon/Moyen/Mauvais)',
  'admin.ai.showSources': 'Afficher les sources',
  'admin.ai.showSourcesDesc': 'Références aux sources de données et aux données de marché dans les réponses',
  'admin.ai.hidePreview': 'Masquer l\'aperçu',
  'admin.ai.showPreview': 'Afficher l\'aperçu',
  'admin.ai.aiBehavior': 'Comportement de l\'IA',
  'admin.ai.length': 'Longueur',
  'admin.ai.liveExample': 'Exemple en direct',
  'admin.ai.testSettings': 'Tester vos paramètres',
  'admin.ai.selectExampleQuestion': 'Sélectionner une question exemple :',
  'admin.ai.userAsks': 'L\'utilisateur demande :',
  'admin.ai.generating': "L'IA génère une réponse...",
  'admin.ai.generateExample': 'Générer une réponse exemple',
  'admin.ai.aiResponds': "L'assistant IA répond :",
  'admin.ai.generateHint': 'Cliquez sur "Générer une réponse exemple" pour voir comment l\'IA répond avec vos paramètres.',
  'admin.ai.reset': 'Réinitialiser',
  'admin.ai.saved': 'Enregistré !',
  'admin.ai.saveSettings': 'Enregistrer les paramètres',

  // --- Table headers ---
  'admin.coupons.code': 'Code',
  'admin.coupons.credits': 'Crédits',

  // --- AI Model Descriptions ---
  'admin.ai.model.standardDesc': 'Analyse équilibrée de haute qualité. Le meilleur choix pour la plupart des évaluations de niches et validations d\'idées.',
  'admin.ai.model.preciseAnalyses': 'Analyses précises',
  'admin.ai.model.bestBalance': 'Meilleur équilibre',
  'admin.ai.model.recommended': 'Recommandé',
  'admin.ai.model.fastDesc': 'Réponses ultra-rapides pour les vérifications rapides de niches, le brainstorming et les évaluations initiales. Idéal quand la vitesse compte.',
  'admin.ai.model.fast': 'RAPIDE',
  'admin.ai.model.fastestResponses': 'Réponses les plus rapides',
  'admin.ai.model.thinkingDesc': 'Analyse approfondie avec une réflexion logique avancée. Pour les analyses de marché complexes, les évaluations critiques et la planification stratégique.',
  'admin.ai.model.deepestAnalysis': 'Analyse la plus approfondie',
  'admin.ai.model.logicalThinking': 'Réflexion logique',
  'admin.ai.model.strategy': 'Stratégie',

  // --- AI Preset Names & Descriptions ---
  'admin.ai.preset.strict.name': 'Analyse stricte',
  'admin.ai.preset.strict.desc': 'Critique, basée sur les faits, sans fioritures. Révèle les faiblesses sans pitié.',
  'admin.ai.preset.extreme.name': 'Analyse EXTREME',
  'admin.ai.preset.extreme.desc': 'Rigueur maximale, critique impitoyable, focus sur le pire scénario. Uniquement pour les vérifications de réalité difficiles.',
  'admin.ai.preset.professional.name': 'Professionnel',
  'admin.ai.preset.professional.desc': 'Objectif, structuré, équilibré. Comme un consultant expérimenté.',
  'admin.ai.preset.realistic.name': 'Réaliste',
  'admin.ai.preset.realistic.desc': 'Honnête et pratique. Concentrez-vous sur la mise en œuvre réalisable et les données de marché réelles.',
  'admin.ai.preset.creative.name': 'Créatif et motivant',
  'admin.ai.preset.creative.desc': 'Inspirant, riche en idées, positif. Trouve des opportunités et des voies non conventionnelles.',
  'admin.ai.preset.balanced.name': 'Équilibré',
  'admin.ai.preset.balanced.desc': 'Bon mélange de critique et de motivation. Le mode par défaut.',
  'admin.ai.preset.investor.name': 'Perspective investisseur',
  'admin.ai.preset.investor.desc': 'Comme un capital-risqueur. Concentrez-vous sur l\'évolutivité, le retour sur investissement et la stratégie de sortie.',
  'admin.ai.preset.startup-coach.name': 'Coach startup',
  'admin.ai.preset.startup-coach.desc': 'Mentor pratique pour les fondateurs. Concentrez-vous sur la mise en œuvre rapide et le produit minimum viable (MVP).',
  'admin.ai.preset.market-researcher.name': 'Chercheur de marché',
  'admin.ai.preset.market-researcher.desc': 'Axé sur les données et analytique. Analyse approfondie du marché et de la concurrence.',
  'admin.ai.preset.risk-analyst.name': 'Analyste des risques',
  'admin.ai.preset.risk-analyst.desc': 'Concentrez-vous sur les risques et les pires scénarios. Pour une planification réaliste.',

  // --- Focus Areas ---
  'admin.ai.focus.marktanalyse': 'Analyse du marché',
  'admin.ai.focus.wettbewerb': 'Concurrence',
  'admin.ai.focus.monetarisierung': 'Monétisation',
  'admin.ai.focus.risiken': 'Risques',
  'admin.ai.focus.finanzen': 'Finances',
  'admin.ai.focus.skalierung': 'Évolutivité',
  'admin.ai.focus.innovation': 'Innovation',
  'admin.ai.focus.trends': 'Tendances',
  'admin.ai.focus.differenzierung': 'Différenciation',
  'admin.ai.focus.umsetzung': 'Mise en œuvre',
  'admin.ai.focus.zielgruppe': 'Groupe cible',
  'admin.ai.focus.marketing': 'Marketing',

  // --- Tone Options ---
  'admin.ai.tone.direkt': 'Direct et franc',
  'admin.ai.tone.professionell': 'Professionnel et objectif',
  'admin.ai.tone.ehrlich': 'Honnête et pratique',
  'admin.ai.tone.motivierend': 'Motivant et positif',
  'admin.ai.tone.freundlich': 'Aimable et bienveillant',
  'admin.ai.tone.akademisch': 'Académique et analytique',

  // --- Example Questions ---
  'admin.ai.question.niche': 'Quelle niche rentable recommandez-vous ?',
  'admin.ai.question.evaluate': 'Évaluez mon idée : Une application pour propriétaires de chiens',
  'admin.ai.question.trends': 'Quelles tendances ont actuellement du potentiel ?',
  'admin.ai.question.sharpen': 'Comment puis-je affiner ma niche ?',

  'admin.ai.rec.bestCombination.title': '🏆 Meilleure combinaison (2 préréglages)',
  'admin.ai.rec.bestCombination.desc': 'Critique mais constructif, avec des mesures d\'action concrètes',
  'admin.ai.rec.bestCombination.useCase': 'Recommandé pour la plupart des analyses',

  'admin.ai.rec.balancedThree.title': '⚖️ Équilibré (3 préréglages)',
  'admin.ai.rec.balancedThree.desc': 'Professionnel, réaliste et convivial pour les investisseurs',
  'admin.ai.rec.balancedThree.useCase': 'Pour des analyses commerciales complètes',

  'admin.ai.rec.creativeDriven.title': '💡 Créatif et motivant (2 préréglages)',
  'admin.ai.rec.creativeDriven.desc': 'Inspirant avec des conseils de mise en œuvre pratiques',
  'admin.ai.rec.creativeDriven.useCase': 'Pour l\'idéation et le brainstorming',

  'pdf.rating.good': 'Bon',
  'pdf.rating.bad': 'Mauvais',
  'pdf.rating.medium': 'Moyen',
  'pdf.header.subtitle': 'Vue d\'Analyse',
  'pdf.footer.tagline': 'Validation de Niche par IA',
  'pdf.footer.page': 'Page',
  'pdf.benchmark.title': 'RÉFÉRENCE DE L\'INDUSTRIE',
  'pdf.benchmark.yourScore': 'Votre Score',
  'pdf.benchmark.top10': 'Top 10% : 85+',
  'pdf.marketAnalysis.title': 'ANALYSE DU MARCHÉ',
  'pdf.summary.title': 'RÉSUMÉ',
  'pdf.structuredSummary.verdict': 'VERDICT',
  'pdf.disclaimer.body': 'Ce rapport a été généré par un modèle d\'IA et est destiné à des fins d\'information uniquement. Il ne constitue pas un conseil financier, juridique, fiscal ou d\'investissement. Les données de marché, les notes et les projections sont des estimations générées par l\'IA et peuvent être incomplètes ou inexactes. Veuillez vérifier toutes les informations de manière indépendante et consulter des professionnels qualifiés avant de prendre des décisions commerciales ou d\'investissement. IdeaVerdict n\'assume aucune responsabilité pour les actions entreprises sur la base de ce rapport.',
  'pdf.disclaimer.title': 'AVIS IMPORTANT',
  'pdf.closing.title': 'Généré par IdeaVerdict',
  'pdf.closing.subtitle': 'Validation de Niche par IA | Intelligence de Marché Complète',
  'history.swot.title': 'Analyse SWOT',
  'history.swot.strengths': 'Forces',
  'history.swot.weaknesses': 'Faiblesses',
  'history.swot.opportunities': 'Opportunités',
  'history.swot.risks': 'Risques',
  'history.sections.recommendations': 'Recommandations',
  'history.sections.marketAnalysis': 'Analyse Concurrentielle',
  'history.sections.microAngles': 'Angles de Micro-Niche',
  'history.sections.improvements': 'Suggestions d\'Amélioration',
  'history.sections.alternatives': 'Niches Alternatives',
  'history.sections.structuredSummary': 'Résumé Structuré (Builder)',
  'history.structuredSummary.strengths': 'Principales Forces',
  'history.structuredSummary.risks': 'Principaux Risques',
  'history.structuredSummary.actions': 'Prochaines Étapes',
  'history.sections.developerBriefing': 'Note au Développeur (Builder)',
  'history.sections.conversation': 'Historique de Conversation',
  'history.conversation.user': 'Utilisateur',
  'history.conversation.assistant': 'IdeaVerdict',
  'history.conversation.structuredResult': 'Résultat Structuré',
  'admin.tabs.usage': 'Utilisation',
  'admin.usage.title': 'Utilisation de l\'IA & Analyse des Couts',
  'admin.usage.refresh': 'Actualiser les données',
  'admin.usage.requests': 'Requêtes',
  'admin.usage.users': 'Utilisateurs',
  'admin.usage.totalTokens': 'Total des Jetons',
  'admin.usage.apiCosts': 'Couts de l\'API',
  'admin.usage.revenue': 'Revenus',
  'admin.usage.margin': 'Marge',
  'admin.usage.byModel': 'Par Modèle',
  'admin.usage.allModels': 'Tous les Modèles',
  'admin.usage.searchEmail': 'Rechercher par adresse e-mail...',
  'admin.usage.perPage': 'Par page :',
  'admin.usage.loading': 'Chargement des données d\'utilisation...',
  'admin.usage.noEntries': 'Aucune entrée trouvée pour les filtres actuels.',
  'admin.usage.time': 'Temps',
  'admin.usage.user': 'Utilisateur',
  'admin.usage.model': 'Modèle',
  'admin.usage.credits': 'Crédits',
  'admin.usage.tokens': 'Jetons',
  'admin.usage.duration': 'Durée',
  'admin.usage.details': 'Détails',
  'admin.usage.showing': 'Affichage de',
  'admin.usage.of': 'sur',
  'admin.usage.entries': 'entrées',
  'admin.usage.firstPage': 'Première Page',
  'admin.usage.prevPage': 'Précédent',
  'admin.usage.page': 'Page',
  'admin.usage.nextPage': 'Suivant',
  'admin.usage.lastPage': 'Dernière Page',
  'admin.usage.requestDetails': 'Détails de la Requête',
  'admin.usage.close': 'Fermer',
  'admin.usage.loadingDetails': 'Chargement des détails...',
  'admin.usage.inputTokens': 'Jetons d\'Entrée',
  'admin.usage.outputTokens': 'Jetons de Sortie',
  'admin.usage.providerCost': 'Cout du Fournisseur',
  'admin.usage.providerBreakdown': 'Répartition du Fournisseur',
  'admin.usage.fullResponseData': 'Données de Réponse Complètes',
  'admin.usage.entryNotFound': 'Cette entrée n\'a pas pu être chargée.',
  'admin.usage.today': 'Aujourd\'hui',
  'admin.usage.last7d': '7 Derniers Jours',
  'admin.usage.last30d': '30 Derniers Jours',
  'admin.usage.allTime': 'Tout le temps',
  'admin.ai.fallbackModel': 'Modèle de Secours',
  'admin.ai.systemPrompts': 'Invites Système',
  'admin.ai.fallbackModelDesc': 'Utilisé lorsque le modèle principal échoue ou renvoie une sortie invalide',
  'admin.ai.systemPromptsDesc': 'Vue en lecture seule des instructions reçues par chaque modèle',
  'admin.ai.provider': 'Fournisseur',
  'admin.ai.modelId': 'ID du Modèle',
  'admin.ai.maxTokens': 'Jetons Max',
  'admin.ai.temperature': 'Température',
  'admin.ai.thinkingBudget': 'Budget de Réflexion',
  'admin.ai.supportsThinking': 'Prend en charge la Réflexion',
  'admin.ai.displayName': 'Nom d\'Affichage',
  'admin.ai.precise': 'Précis',
  'admin.ai.creativeTemp': 'Créatif',

  // Header + Sidebar (auto-added by rebrand)
  'header.openMenu': 'Ouvrir le menu',
  'header.home': 'Accueil',
  'header.notifications': 'Notifications',
  'header.settings': 'Paramètres',
  'header.profile': 'Profil',
  'sidebar.collapse': 'Réduire la barre latérale',
  'sidebar.expand': 'Développer la barre latérale',
  'sidebar.close': 'Fermer le menu',
  'sidebar.plan': 'Plan',
  'sidebar.backToWebsite': 'Retour au site',

  // Legal — Imprint (auto-added)
  'legal.imprint.title': 'Mentions légales',
  'legal.imprint.company': 'Scherbius Technology',
  'legal.imprint.location': 'Dubaï, Émirats Arabes Unis (EAU)',
  'legal.imprint.seatLabel': 'Siège social',
  'legal.imprint.seatBody': 'Dubaï, Émirats Arabes Unis',
  'legal.imprint.contactLabel': 'Contact',
  'legal.imprint.contactBody': 'Les coordonnées sont fournies à la seule discrétion de Scherbius Technology.',
  'legal.imprint.representationLabel': 'Représentation légale',
  'legal.imprint.representationBody': 'Scherbius Technology est représentée par ses représentants légaux conformément au droit des Émirats Arabes Unis.',
  'legal.imprint.contentLiabilityLabel': 'Responsabilité du contenu',
  'legal.imprint.contentLiabilityBody': 'Les contenus de ce site ont été créés avec le plus grand soin possible.\nScherbius Technology n\'assume toutefois aucune responsabilité quant à l\'exactitude, l\'exhaustivité ou l\'actualité des contenus.',
  'legal.imprint.linksLiabilityLabel': 'Responsabilité des liens externes',
  'legal.imprint.linksLiabilityBody': 'Ce site peut contenir des liens vers des sites externes de tiers sur lesquels nous n\'avons aucun contrôle.\nAucune responsabilité n\'est assumée pour ces contenus externes.',
  'legal.imprint.lawLabel': 'Droit applicable',
  'legal.imprint.lawBody': 'Le droit des Émirats Arabes Unis s\'applique exclusivement.\nLe tribunal compétent est Dubaï, EAU.',

  // Overview page (auto-added)
  'overview.greeting': 'Bon retour',
  'overview.greetingSub': 'Voici ce qui se passe sur ton bureau de verdicts.',
  'overview.heroCta': 'Nouveau verdict',
  'overview.currentPlan': 'Forfait actuel',
  'overview.creditsLabel': 'crédits',
  'overview.usedThisCycle': 'Utilisés ce cycle',
  'overview.resetsOn': 'Réinitialisation le',
  'overview.unlimitedTitle': 'Illimité',
  'overview.builderPerk': 'Tu as un accès Builder complet — sans plafond.',
  'overview.runOne': 'Lancer un verdict',
  'overview.lastVerdicts': 'Tes 5 derniers verdicts',
  'overview.noActivity': 'Pas encore de verdicts — lance ta première analyse',
  'overview.tipTitle': 'Astuce',
  'overview.tipBody': 'Passe une idée par deux langues — si le verdict s\'adoucit, tes hypothèses sont locales, pas universelles.',
  'onboard.skip': "Passer",
  'onboard.cta.next': "Suivant",
  'onboard.cta.start': "Commencer",
  'onboard.s1.title': "Bienvenue sur IdeaVerdict",
  'onboard.s1.body': "Un verdict IA sur votre idée d'entreprise — avant de la construire.",
  'onboard.s2.title': "Verdicts brutalement honnêtes",
  'onboard.s2.body': "Pas de battage, pas de flatterie. Données de marché réelles, concurrents réels, risques réels.",
  'onboard.s3.title': "Rapports Builder en PDF",
  'onboard.s3.body': "Générez des rapports de 25 à 75 pages avec architecture complète, finances et stratégie go-to-market.",
  'onboard.s4.title': "Prêt quand vous l'êtes",
  'onboard.s4.body': "Inscrivez-vous et obtenez votre premier verdict en moins d'une minute.",
  'builderReport.title': "Création de votre Builder Report",
  'builderReport.subtitle': "Analyse complète + briefing développeur — téléchargé en PDF dès qu'il est prêt.",
  'builderReport.idea': "Votre idée",
  'builderReport.ideaPlaceholder': "Décrivez votre idée d'entreprise (ou laissez vide pour utiliser la dernière idée discutée)…",
  'builderReport.cta': "Générer le rapport",
  'builderReport.credits': "crédits",
  'builderReport.deductedNow': "Débité à la réussite",
  'builderReport.dontClose': "Veuillez ne pas fermer cette fenêtre — la génération peut prendre 30-90 secondes.",
  'builderReport.done': "PDF téléchargé — vérifiez votre dossier de téléchargements.",
  'builderReport.failed': "Échec de la génération",
  'builderReport.close': "Fermer",
  'builderReport.cancel': "Annuler",
  'builderReport.running': "Génération…",
  'builderReport.retry': "Réessayer",
  'builderReport.unknownError': "Échec de la génération. Vos crédits devraient être remboursés.",
  'builderReport.signInRequired': "Vous devez être connecté pour générer un rapport.",
  'builderReport.ideaRequired': "Veuillez décrire votre idée pour que l'IA ait quelque chose à analyser.",
  'builderReport.fromChat': "De votre conversation actuelle",
  'builderReport.noIdeaDetected': "Nous utilisons l'idée dont nous discutons.",
  'builderReport.contextHint': "L'IA utilisera tout ce chat — aucune nouvelle idée ne sera inventée.",
  'builderReport.step.core': "Génération de l'analyse principale",
  'builderReport.step.market': "Ajout de l'analyse de marché étendue",
  'builderReport.step.tech': "Ajout de l'architecture technique",
  'builderReport.step.financials': "Ajout des modèles financiers",
  'builderReport.step.compet': "Ajout de l'intelligence concurrentielle",
  'builderReport.step.gtm': "Ajout de la stratégie go-to-market",
  'builderReport.step.deepdive': "Ajout de l'analyse sectorielle approfondie",
  'builderReport.step.pdf': "Compilation du PDF…",
  'briefing.title': "Création de votre briefing développeur",
  'briefing.subtitle': "Briefing technique en 11 sections — téléchargé en PDF dès qu'il est prêt.",
  'briefing.ideaPlaceholder': "Décrivez votre idée d'entreprise (ou laissez vide pour utiliser la dernière idée discutée)…",
  'briefing.cta': "Générer le briefing",
  'briefing.step.core': "Génération du briefing développeur",
  'briefing.step.pdf': "Compilation du PDF…",
  'pricing.gold.name': "Gold",
  'pricing.gold.description': "Plus de crédits + rapports de 50 pages",
  'pricing.gold.credits': "12 500 crédits par mois",
  'pricing.platinum.name': "Platinum",
  'pricing.platinum.description': "Niveau maximum + rapports de 75 pages",
  'pricing.platinum.credits': "15 000 crédits par mois",

  // ─── Auto-backfilled from EN (2026-05-13) ───
  // These are English fallbacks for keys that hadn't been translated to
  // "fr" yet. Replace with native translations as needed.
  'nav.slogan': 'An AI verdict on your business idea — before you build',
  'chat.creditsPerQuestion': 'Credits/question',
  'chat.notEnoughCreditsTitle': 'Not enough credits',
  'chat.notEnoughCreditsDesc': 'You need at least {{cost}} credits per question.',
  'chat.creditsRunningLow': 'Credits running low',
  'chat.questionsRemaining': '{{count}} questions remaining.',
  'chat.noCreditsModalTitle': 'Not enough credits',
  'chat.noCreditsModalDesc': 'You need at least <1>{{cost}} credits</1> per question. Your current balance: <2>{{balance}} credits</2>',
  'chat.currentPlan': 'Current plan',
  'chat.close': 'Close',
  'chat.upgrade': 'Upgrade',
  'sub.manageBilling': 'Manage billing',
  'credits.topup.buyMore': 'Buy more credits',
  'trial.creditsLow': "Plus que {{count}} crédits !",
  'trial.upgradeNow': "Passer à supérieur",
  'trial.upgradeNowArrow': "Mettre à niveau →",
  'trial.creditsExhausted': "Crédits épuisés",
  'trial.upgradeForUnlimited': "Passez à supérieur pour un usage illimité",
  'trial.noCreditsPlaceholder': "Plus de crédits disponibles…",
  'hero.badgeHonest': "IA honnête et impartiale",
  'hero.badge60sec': "Verdict en 60 secondes",
  'hero.badge20Lang': "20+ langues",
  'hero.widget.label': "Verdict d'idée",
  'hero.widget.passed': "VALIDÉ",
  'hero.widget.demoIdea': "Tuteur IA pour étudiants en médecine",
  'hero.widget.market': "Marché",
  'hero.widget.demand': "Demande",
  'hero.widget.competition': "Concurrence",
  'hero.widget.verdictReady': "Verdict prêt · 47 sec",
  'hero.widget.riskFlagged': "Risque signalé",
  'hero.widget.crowdedMarket': "Marché saturé · 4 acteurs",
  'hero.widget.suggestedPivot': "Pivot suggéré",
  'hero.widget.nicheBySpecialty': "Niche par spécialité",
  'hero.widget.feasibilityGain': "+38% de faisabilité",
  'hero.widget.analysisDone': "Analyse terminée",
  'hero.widget.metrics56': "5 sur 6 métriques",
  'hero.stats.verdictSpeed': "Vitesse du verdict",
  'cta.badge': "Verdict en 60 secondes",
  'cta.subtitleEnd': "sans deviner.",
  'cta.signinPrompt': "Vous avez déjà un compte ? Connectez-vous",
  'cta.trustTrial': "Essai gratuit de 7 jours",
  'cta.trustNoCard': "Pas de carte requise",
  'cta.trustCancel': "Annulez à tout moment",
  'footer.themeLabel': "Thème :",
  'footer.lightMode': "Mode clair",
  'footer.darkMode': "Mode sombre",
  'footer.sectionProduct': "Produit",
  'footer.sectionLegal': "Mentions légales",
  'nav.switchLight': "Passer en mode clair",
  'nav.switchDark': "Passer en mode sombre",
  'features.badge': "Pourquoi IdeaVerdict",
  'features.mainFeatureLabel': "Titre",
  'chatError.planRestriction': "Cette fonctionnalité nécessite un plan supérieur.",
  'chatError.creditDeduction': "Échec du paiement. Veuillez réessayer.",
  'chatError.aiService': "Le service IA est temporairement indisponible. Vos crédits n'ont pas été débités. Réessayez plus tard.",
  'chatError.parseError': "Format de réponse inattendu. Veuillez réessayer.",
  'chatError.sessionExpired': "Votre session a expiré. Reconnectez-vous.",
  'chatError.timeout': "La requête a pris trop de temps. Veuillez réessayer.",
  'chatError.generic': "Impossible d'obtenir une réponse. Veuillez réessayer.",

  // ─── Auto-backfilled from EN (2026-05-13) ───
  // These are English fallbacks for keys that hadn't been translated to
  // "fr" yet. Replace with native translations as needed.
  'faq.badge': "FAQ",
  'trial.lowCredits': "Only {credits} credits left!",
  'trial.outOfCredits': "Out of credits",
  'trial.outOfCreditsDesc': "Upgrade to keep getting verdicts.",
  'trial.viewPlans': "View plans",
  'trial.tryDemo': "Try the demo",
  'hero.widget.crowded': "Crowded market · 4 incumbents",
  'hero.widget.nicheBySpec': "Niche by specialty",
  'hero.widget.feasibilityUp': "+38% feasibility",
  'hero.widget.fiveOfSix': "5 of 6 metrics",
  'builderReport.modalTitle': "Builder Report",
  'builderReport.modalSubtitle': "Generate a comprehensive PDF for your idea",
  'builderReport.formatLabel': "Report format",
  'builderReport.formatStandard': "Standard report",
  'builderReport.formatExec': "Executive summary",
  'builderReport.toneLabel': "Tone",
  'builderReport.toneProfessional': "Professional",
  'builderReport.toneCasual': "Casual",
  'builderReport.toneTechnical': "Technical",
  'builderReport.sectionsLabel': "Sections to include",
  'builderReport.sectionMarket': "Market analysis",
  'builderReport.sectionCompetition': "Competitive landscape",
  'builderReport.sectionFinancial': "Financial model",
  'builderReport.sectionArchitecture': "Technical architecture",
  'builderReport.sectionGTM': "Go-to-market plan",
  'builderReport.sectionRisks': "Risk register",
  'builderReport.sectionRoadmap': "Product roadmap",
  'builderReport.sectionTeam': "Team & hiring plan",
  'builderReport.actionGenerate': "Generate report",
  'builderReport.actionCancel': "Cancel",
  'builderReport.actionDownload': "Download PDF",
  'builderReport.statusGenerating': "Generating your report…",
  'builderReport.statusComplete': "Report ready",
  'builderReport.statusError': "Something went wrong. Try again.",
  'builderReport.creditsRequired': "This will use {credits} credits.",
  'builderReport.pageCount': "{pages} pages",
  'builderReport.tip1': "Tip: be specific about your target customer for sharper analysis.",
  'builderReport.tip2': "Tip: include early revenue numbers if you have them.",
  'builderReport.tip3': "Tip: mention your tech preferences if any.",
  'builderReport.errorNotEnough': "You don't have enough credits for this report.",
  'builderReport.errorUpgrade': "Upgrade to a higher plan",
  'builderReport.errorTryStandard': "Try the Standard report instead",
  'builderReport.success': "Your Builder Report is ready.",
  'builderReport.previewBadge': "Preview",
  'builderReport.previewNote': "This is a preview. Generate the full PDF to see all sections.",
  'builderReport.includesLabel': "Includes",
  'builderReport.pagesIncluded': "{pages} pages of analysis",
  'builderReport.estimatedTime': "Estimated time: {minutes} min",
  'builderReport.fullReport': "Full report",
  'builderReport.execSummary': "Executive summary",
  'pricing.builder.report': "Builder Report de 25 pages",
  'pricing.gold.report': "Builder Report de 50 pages",
  'pricing.platinum.report': "Builder Report de 75 pages",
  'auth.bestValue': "Meilleur rapport",
  'auth.elite': "Élite",
  'builderReport.friendlyError': "Nous n'avons pas pu finaliser votre rapport cette fois. Vos crédits n'ont pas été débités — veuillez réessayer dans un instant.",
  'builderReport.persistHint': "Si le problème persiste, contactez support@ideaverdict.ai.",
};
